import React, { Component, createRef } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Flex, Toast, PullToRefresh, Modal } from 'antd-mobile';
import Util from 'utils';
import { initConfig } from 'utils/wxUtils';
import cx from 'classnames';
import { FrameWork, ImgWrap, Footer, DownloadBar } from 'pubBiz';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import { fetchData } from 'pubBiz/ActiveAdPopup/fetchData';
import { CardOpenTip } from 'widget';
import Accoumnlate from 'widget/Accoumulate/AccoumulateView';
import AccoumnlateV2 from 'widget/AccoumulateV2/AccoumulateView';
import Tabs from './components/Tabs';
import {
  BannerCell,
  ArticleCell,
  ModuleCell,
  RecommandCell,
  ThreeCell,
  ImgTextCell,
  ClassifyCell,
  AdPictureCell,
  GoodsFloorCell,
  TitleCell,
  GoodsCell,
  SliderCell,
  LinkStoreInfoCell,
  StoreInfoCell
} from 'pubBiz/CommonCell';

import config from 'config/Config';
import './ShopHomeLess.less';
import { toJS } from 'mobx';
import { floatTool } from 'utils/math';
import dayjs from 'dayjs';
import { addCart as addCartUtil, getMsgCount as getMsgCountUtil } from 'utils/commonRequest/shoppingCart';
import { preloadMods } from 'utils/storeRuntime/dynamicInject';

import {
  routeAuthCodeMap,
  popupPositionMap,
  xverseParams,
  descriptionList,
  ghObj,
  MallType
} from 'utils/constants';
import { isHasRouteAuth } from 'utils/authUtil';
import { rstr2b64, hex_md5 } from 'utils/md5';
import moment from 'moment';
import RedEnvelopeRain from './components/RedEnvelopeRain/RedEnvelopeRainView';
import XversePopup from './components/XversePopup';
import LoginBottomTip from 'components/LoginBottomTip';
import BuyAgainBar from 'pages/Shop/Home/ShopHome/components/BuyAgainBar';
import HeaderMessageAlert from 'components/Message/headerAlert';
import ToRecommenderWeapp from 'pages/Shop/Home/ShopHome/components/ToRecommenderWeapp';
import goLdMiniProgram from 'functions/goThirdMiniProgram';
import CommonMiniModal from 'components/CommonMiniModal';
import { showToWeapp } from 'pages/Shop/Home/ShopHome/components/ToWeapp';
import MustBuyModal from 'pages/Shop/components/MustBuyModal';
import { parseCustomLink } from 'biz-micro-services-ui/project/middlePlatform/function/util';
import CombinedRecommend from 'biz-micro-services-ui/project/pria/pages/home/CombinedRecommend/index';
import LiveList from 'biz-micro-services-ui/project/performance/pages/home/components/LiveList';
import styles from './index.modules.less';
import AccumulatePriceTip from 'biz-micro-services-ui/project/middlePlatform/components/AccumulatePriceTip';
import QualificationItemList from 'biz-micro-services-ui/project/middlePlatform/components/QualificationItemList';
import { getCrossIndustryHiBuyUrl } from 'biz-micro-services-ui/project/middlePlatform/function/util';
const cellMargin = '0.24rem';
const CDN_BASE = config.CDN_BASE || '';
const { FloorFrame, Shape } = FrameWork;
const SANSICON =
  'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/direct_prod/z5bfdjHTHZ.com/70aa43f5-305c-41a6-aee7-274e48b7b8dc';
const modal_mini_program_image = 'https://image.yofogo.com/images/common/mini_program_image.png';
const modal_fnbl_program_image = 'https://image.yofogo.com/images/common/fnbl_program_image.png';

/**
 * 导航栏 TabBar 画布拼接组件
 * 把 N 张切片图画到「同一张 canvas」上，按整数设备像素严格首尾相接绘制
 * （第 i 段结束像素 == 第 i+1 段起始像素），单一位图无内部边界，
 * 从根本上消除高倍屏(如 iPhone12Pro DPR3)下相邻切片之间露底色的 1px 缝隙，
 * 同时各段等分、连贯拼接的图片精准对齐。
 */
class NavTabBarCanvas extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = createRef();
    this.imgCache = {}; // url -> HTMLImageElement，跨状态复用，切换不重复加载
    this.ro = null;
    this.drawSeq = 0; // 防止异步绘制乱序
  }

  componentDidMount() {
    if (typeof ResizeObserver !== 'undefined' && this.canvasRef.current) {
      this.ro = new ResizeObserver(() => this.draw());
      this.ro.observe(this.canvasRef.current);
    }
    this.preload();
    this.draw();
  }

  componentDidUpdate(prevProps) {
    // 浅比较：只有 slices 引用变化才重绘，避免父组件频繁 re-render 导致不必要的 canvas 重绘
    const slicesChanged = prevProps.slices !== this.props.slices;
    const preloadUrlsChanged = prevProps.preloadUrls !== this.props.preloadUrls;

    if (slicesChanged) {
      this.draw();
    }
    if (preloadUrlsChanged) {
      this.preload();
    }
  }

  componentWillUnmount() {
    if (this.ro) {
      this.ro.disconnect();
      this.ro = null;
    }
  }

  // 预加载所有状态用到的图，避免切换时闪白
  preload = () => {
    (this.props.preloadUrls || []).forEach((u) => u && this.loadImg(u));
  };

  loadImg = (url) => {
    return new Promise((resolve) => {
      const cached = this.imgCache[url];
      if (cached) {
        if (cached.complete && cached.naturalWidth) return resolve(cached);
        cached.addEventListener('load', () => resolve(cached), { once: true });
        cached.addEventListener('error', () => resolve(null), { once: true });
        return;
      }
      const img = new Image();
      // 不设置 crossOrigin：仅用于绘制展示，无需读回像素，避免 CDN 无 CORS 头时加载失败
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = url;
      this.imgCache[url] = img;
    });
  };

  draw = async () => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;
    const cssW = canvas.clientWidth;
    const cssH = canvas.clientHeight;
    if (!cssW || !cssH) return;
    const slices = this.props.slices || [];
    const N = slices.length;
    if (!N) return;

    const seq = ++this.drawSeq;
    const imgs = await Promise.all(slices.map((u) => this.loadImg(u)));
    if (seq !== this.drawSeq) return; // 已有更新的绘制发起，丢弃本次
    if (!this.canvasRef.current) return;

    const dpr = window.devicePixelRatio || 1;
    const wDev = Math.round(cssW * dpr);
    const hDev = Math.round(cssH * dpr);
    if (canvas.width !== wDev) canvas.width = wDev;
    if (canvas.height !== hDev) canvas.height = hDev;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, wDev, hDev);
    // 关键：按整数设备像素首尾相接，无缝无叠
    let prev = 0;
    for (let i = 0; i < N; i++) {
      const end = Math.round(((i + 1) * wDev) / N);
      const w = end - prev;
      // 确保图片加载成功且有有效尺寸才绘制，避免加载失败时报错
      if (imgs[i] && imgs[i].complete && imgs[i].naturalWidth > 0 && w > 0) {
        ctx.drawImage(imgs[i], 0, 0, imgs[i].naturalWidth, imgs[i].naturalHeight, prev, 0, w, hDev);
      }
      prev = end;
    }
  };

  render() {
    return (
      <canvas ref={this.canvasRef} style={{ width: '100%', height: '100%', display: 'block' }} />
    );
  }
}

@inject('AppMod')
@inject('ShopHomeMod')
@withRouter
@observer
class ShopHomeView extends Component {
  constructor(props, context) {
    super(props, context);

    this.appStore = this.props.AppMod;
    this.stores = this.props.ShopHomeMod;

    // 本地状态管理消息数量（不再依赖 PersonalMod）
    this.state = {
      ...this.state,
      msgCount: 0
    };

    // 缓存 Tab 预加载 URL 列表，避免每次 render 都重新生成数组
    this.tabPreloadCache = { key: '', urls: [] };
    // Util.setLocalCache('supplement_data', {
    //   isSupplementCard: 'L000003',
    //   supplementCardCode: '1',
    // });

    this.stores.changeState({ showSupplementModal: false });
    const supplementData = Util.getLocalCache('supplement_data') || {};
    let isSupplementCard = supplementData.isSupplementCard || 0;
    let supplementCardCode = supplementData.supplementCardCode || '';
    // console.log('难道有值??', window.location.href.split('?'));
    if (window.location.href.split('?') && window.location.href.split('?')[1]) {
      isSupplementCard =
        Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1]))
          .isSupplementCard ||
        supplementData.isSupplementCard ||
        0;
      supplementCardCode =
        Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1]))
          .supplementCardCode ||
        supplementData.supplementCardCode ||
        '';
      // 缓存权益共享卡信息
      Util.setLocalCache('supplement_data', {
        isSupplementCard,
        supplementCardCode
      });
      isSupplementCard && !this.appStore.token && Util.setLocalCache('loginGoback', true);
    }
    this.state = {
      isSupplementCard, // 是否是权益共享卡跳转
      supplementCardCode, // 权益共享卡的主卡卡号
      showSupplementModal: false, // 权益共享卡弹窗
      bannerHeight: 0,
      navbarHeight: 0,
      navbarOpacity: 0, // 导航栏透明度
      isShowFixBar: false, // 是否隐藏导航栏，下拉刷新时为true
      showCoupon: false,
      carouselIndex: 1, // 当前的轮播图的index
      carouselProductIndex: 1,
      AccoumnlateStatus: false,
      showMustBuyModal: false, // 销售专区-必选产品提示弹窗
      // upgrate: true,
      // showModal: false,
      showCarnivalModal: false,
      showCarnivalWeapplUrl: '', // 小程序链接
      showCarnivalWeapplShareCard: '', // 小程序分享图片
      // member_userInfo: {},
      isHide: false,
      // showWeappModal: false, // 打开小程序弹窗
      // liveRoomId: '', // 直播间ID
      // liveCoverUrl: '', // 直播封面
      // showWeappModalAdd: false, // 打开小程序添加企微好友弹窗
      // weappChatAddId: '', // 企微好友ID
      showQuesModal: false,
      showGoYundianOpenShop: false, // 打开小程序到申请开店页
      showImproveInfoModal: false, // 完善资料弹框标识
      wechatAppid: 'gh_62517e9b6920', // 原始ID，正式：gh_62517e9b6920蜂鸟，gh_825754bbda7f有享小店
      upArrow: false
    };
    this.tabsRef = createRef();
    this.tabsStickyRef = createRef();
    this.tabsViewRef2 = createRef();
    this.miniDateRef = createRef();
    this.containerDom = null;
    this.containerInnerDom = null;
    this.qualificationItemListRef = null; // 资格购产品列表 ref
    this.routesValue = '';
    this.showImgUrl = '';
    const isWeChat = Util.isWeiXin();
    console.log('isWeChatisWeChat', isWeChat);
    if (isWeChat) {
      initConfig(true);
    }
    this.throttleWin = () => {};
    this.interval = null; // 定时器
    this.topValue = 0; // 上次滚动条到顶部的距离
    let questId = '';
    let questUserId = '';
    if (window.location.href.split('?') && window.location.href.split('?')[1]) {
      questId = Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1])).questId;
      questUserId = Object.fromEntries(
        new URLSearchParams(window.location.href.split('?')[1])
      ).questUserId;
      // 通过唯一标识 onlineAddress userId 进入首页的店铺信息栏位逻辑
      const { onlineAddress, userId } =
        Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1])) || {};
      if (onlineAddress === '1') {
        Util.setLocalCache('onlineAddress', onlineAddress);
        Util.setLocalCache('onlineUserId', userId);
      }
    }
    if (questUserId == 1) {
      sessionStorage.setItem('queryQuestUserId', questId);
      window.app.routerGoTo(`/personal/QuestionnaireView?id=${questId}&userId=${questUserId}`);
      setTimeout(() => {
        sessionStorage.setItem('queryQuestUserId', '');
      }, 1000);
    }
  }

  async componentDidMount() {
    // this.appStore.getSatisfiedInfo(9)
    console.log('uaaaa', window.navigator.userAgent);
    if (this.props.mode == 'finding') {
      this.props.onRef && this.props.onRef(this);
      return;
    }
    // 记录来源
    this.stores.changeState({
      homeCarouselIndex: 1,
      THIS: this,
      showWeappModal: false, // 打开小程序弹窗
      liveRoomId: '', // 直播间ID
      liveCoverUrl: '', // 直播封面
      showWeappModalAdd: false, // 打开小程序添加企微好友弹窗
      weappChatAddId: '' // 企微好友ID
    });
    const fromOrigin = sessionStorage.getItem('fromOrigin');
    !!fromOrigin && this.tranckOrigin(fromOrigin);
    // 获取活动
    this.stores.getActiveAdList({ popupPosition: popupPositionMap.HOME });

    this.setState({
      bannerHeight: document.getElementById('home-banner').offsetHeight,
      navbarHeight: document.getElementById('home-nav').offsetHeight
    });
    if (this.appStore.token) {
      this.stores.getDelayList();
      this.stores.queryRepeatPrompt();
    }
    // 获取优惠券弹框
    const member_userInfo = Util.getLocalCache(config.localStorageKeys.member_userInfo) || {};

    if (Object.keys(member_userInfo).length > 0) {
      this.stores.changeState({ hasPermissions: false });
      this.stores.getCouponData().then((res) => {
        if (res) {
          const object = {
            count: res,
            show: true
          };
          const value = Util.getLocalCache('couponTip');
          if (!value) {
            this.setState({ showCoupon: object.show });
            Util.setLocalCache('couponTip', object);
          } else {
            this.setState({ showCoupon: value.show });
          }
        } else {
          this.setState({ showCoupon: false });
        }
      });
      if (window.app.router.action === 'PUSH') {
        this.appStore.getUserInfo(true, false).then((res) => {
          const {
            cardCode,
            remindTag,
            supplementInfo,
            saleConsultantCardCode,
            healthConsultantNum,
            accumulateIsOpenCard, // 是否是开卡 1-是 0-否
            accumulateMustBuyTag // 销售专区累计制是否有未买的必选产品 1-有，0-meiyou
          } = Util.getLocalCache(config.localStorageKeys.member_userInfo) || {};
          // remindTag && !!supplementInfo && this.setState({AccoumnlateStatus: true});
          if (remindTag == 1) {
            if (accumulateMustBuyTag == 1) {
              // 是否有累计制未买的必选产品，有升级必购的弹窗就不弹累计制的弹窗了
              this.setState({ showMustBuyModal: true });
              return;
            }
            if (supplementInfo) {
              this.setState({ AccoumnlateStatus: true });
            } else {
              const params = {
                healthConsultantNum: healthConsultantNum || '8888888888',
                saleConsultantNum: saleConsultantCardCode || healthConsultantNum || '8888888888',
                channel: 0,
                isEntityCard: 0
              };
              let newParams = params;
              if (accumulateIsOpenCard) {
                this.stores.changeState({ upgrate: false });
                let psd = '123456';
                newParams = { ...params, password: rstr2b64(psd) };
              }
              this.stores.accumulateUserInfo(newParams).then((resp) => {
                this.stores.changeState({ showModal: true, member_userInfo: resp });
              });
            }
          }
        });
      }
    }

    // 获取权益共享卡绑定信息
    if (this.appStore.token && this.state.isSupplementCard == 1) {
      const userId = this.props.AppMod.userInfo.id || '';
      const supplementParam = {
        equityUserId: userId,
        masterCard: this.state.supplementCardCode
      };
      this.getEquityCardInfo(supplementParam);
    }

    // 获取首页数据
    // tab 楼层在页面底部，内容异步加载完成后页面变高，需要在数据就绪后补一次滚动恢复
    this.stores.refreshData().then(() => {
      // 仅当页面有 tab 楼层时才补一次恢复：
      // tab 内容异步加载会撑高页面，第一次 scrollTo 可能没打到位
      if (scrollTop > 0 && this.containerDom && this.stores.tabBarList.length > 0) {
        requestAnimationFrame(() => {
          this.containerDom.scrollTo(0, scrollTop);
        });
      }
    });
    if (Util.getLocalCache('onlineAddress') === '1' && !!Util.getLocalCache('onlineUserId')) {
      this.stores.getLinkStoreInfo(Util.getLocalCache('onlineUserId'));
    }
    // 获取预售、拼团、秒杀 - 即将开始数据
    this.stores.getSeckillWill(7);
    this.stores.getSeckillWill(8);
    this.stores.getSeckillWill(9);
    // 查询用户资格购
    if (this.appStore.token) {
      this.stores.getQueryActiveActivityList();
      this.stores.getQualificationList();
      if (this.appStore.isLY) {
        // 老鹰提示页面判断
        this.props.AppMod.getCheckDomainTips('LY');
      }
    }
    console.log('this.stores.isShowPoster', this.appStore.homePopupShow);

    // 获取有无新消息
    if (this.appStore.token) {
      getMsgCountUtil().then((count) => {
        this.setState({ msgCount: count });
      });
      this.stores.getUpgradeRecent('home').then((AccoumnlateStatusV2) => {
        if (!this.appStore.homePopupShow && !AccoumnlateStatusV2) {
          this.stores.isShowPoster && this.stores.queryNewcomer();
          !this.stores.isShowPoster && fetchData({ popupPosition: popupPositionMap.HOME });
          this.appStore.changeState('homePopupShow', true);
        }
      });
      // 获取消息
      // this.appStore.queryHeadMsgForPull()
    } else {
      !this.appStore.homePopupShow && fetchData({ popupPosition: popupPositionMap.HOME });
      this.appStore.changeState('homePopupShow', true);
      this.setState({ msgCount: 0 });
    }
    // 处理滑动位置
    const { scrollTop } = this.stores;
    const homeDome = document.getElementById('shop-home');
    this.containerDom = homeDome.getElementsByClassName('am-pull-to-refresh')[0];
    this.containerInnerDom = homeDome.getElementsByClassName('am-pull-to-refresh-content')[0];
    // 立即恢复：对 tab 以外的楼层（缓存数据已渲染，高度稳定）有效
    if (scrollTop > 0) {
      this.containerDom.scrollTo(0, scrollTop);
    }

    // 用户未登陆请求权限接口，三生体系默认获取公司权限点，新体系获取本体系的配置(请求头增加System-Code)
    if (!this.appStore.token) {
      if (Util.getQueryString('systemCode') || sessionStorage.getItem('systemCode')) {
        this.stores.getEnterList();
      } else {
        this.stores.getGongSiEnterList();
      }
    }

    const { token, userType, userInfo } = this.appStore;
    // 完善资料提示框
    // if(token) {
    //   Promise.all([
    //     this.appStore.getPaymentAmount({userId: userInfo.id}),
    //     this.appStore.queryVipReminderForFront(),
    //     this.personalStore.getUserShouldSupply(),
    //   ]).then(([res1, res2, res3]) => {
    //     if(res1 && res2 && res2.data.vipPayment && res1.data >= res2.data.vipPayment) {
    //       // 确认合同：0 - 是，1 - 否
    //       // 提醒了但是 没有确认合同
    //       if(res2 && res2.data && res2.extFields && res2.extFields.agreementConfirmTimes <= 0) {
    //         window.app.routerGoTo({
    //           pathname: '/agreements/topicAgreement',
    //           state: {
    //             id: res2.data.mobileTopicId,
    //           },
    //         });
    //         return
    //       }
    //       this.setState({
    //         showImproveInfoModal: true
    //       })
    //       // 补充资料弹窗
    //       if(res3) {
    //         Util.improveInfoModal({userType, cardCode: userInfo.cardCode}, () => {
    //           this.setState({
    //             showImproveInfoModal: false
    //           })
    //         })
    //       } else {
    //         this.setState({
    //           showImproveInfoModal: false
    //         })
    //       }
    //     } else {
    //       this.setState({
    //         showImproveInfoModal: false
    //       })
    //     }
    //   }).catch(error => {
    //     this.setState({
    //       showImproveInfoModal: false
    //     })
    //     console.log("error>>>>", error)
    //   })
    // }
  }

  getEquityCardInfo = async (supplementParam) => {
    await this.stores.getrRcommendPageInfo('1370824983965889552');
    await this.stores.getrServerTime();
    this.stores.getEquityCard(supplementParam);
  };

  observeStop = (v) => {
    // 判断此刻到顶部的距离是否和1秒前的距离相等
    console.log(v, this.topValue);
    if (v == this.topValue) {
      console.log('scroll bar is stopping!');
      clearInterval(this.interval);
      this.interval = null;
      this.setState({ isHide: false });
    } else {
      this.topValue = v;
      this.setState({ isHide: true });
    }
  };

  // 记录来源
  tranckOrigin = (fromOrigin) => {
    const { userInfo } = this.appStore || {};
    const { cardCode = '', userId = '', realName = '' } = userInfo || {};
    window.sensors.track('fromOrigin', {
      userId,
      cardCode,
      realName,
      source: fromOrigin
    });
  };

  // 各个功能点击次数统计埋点
  tranckFunctionClick = (name, authCode = '') => {
    const { userInfo } = this.appStore;
    const { cardCode } = userInfo || {};
    window.sensors.track('functionClickCount', {
      authCode, // 权限点名称
      name, // 功能名字
      cardCode,
      belongSystem: this.props.AppMod.userInfo && this.props.AppMod.userInfo.belongSystem, // 站点
      position: '首页', // 位置
      source: 'H5' // 来源
    });
  };

  /**
   * @description 校验首页去登录按钮旁边是否显示去顶部的箭头
   */
  slidingToTopClipper = ({ moveY, showDownBar }) => {
    const showDownBarHeight = showDownBar ? 121 : 0;
    const onePageHeight = Util.vhToPx(100) - 96 - 88 - showDownBarHeight;
    const { upArrow: u } = this.state || {};
    const canShow = moveY >= onePageHeight;
    const setArrow = (s) => this.setState({ upArrow: s });
    u && !canShow && setArrow(false);
    !u && canShow && setArrow(true);
  };

  getKeyFunc = ({ key, func }) => {
    return this[key] && this[key].current && this[key].current[func]();
  };

  checkStickyScrollHeight = (scrollTop) => {
    const addLength = scrollTop + 152;
    const top = this.tabsRef && this.tabsRef.current && this.tabsRef.current.offsetTop;
    if (top <= addLength) {
      // 吸顶
      !this.getKeyFunc({ key: 'tabsStickyRef', func: 'getShowStatus' }) &&
        this.getKeyFunc({ key: 'tabsStickyRef', func: 'show' });
      !!this.getKeyFunc({ key: 'tabsViewRef2', func: 'getShowStatus' }) &&
        this.getKeyFunc({ key: 'tabsViewRef2', func: 'hiddenTitle' });
    } else {
      !this.getKeyFunc({ key: 'tabsViewRef2', func: 'getShowStatus' }) &&
        this.getKeyFunc({ key: 'tabsViewRef2', func: 'show' });
      !!this.getKeyFunc({ key: 'tabsStickyRef', func: 'getShowStatus' }) &&
        this.getKeyFunc({ key: 'tabsStickyRef', func: 'hiddenTitle' });
    }
  };

  /**
   * 保存滑动位置
   */
  saveScrollTop = (e, showDownBar) => {
    const scrollTop = this.containerDom.scrollTop;
    // this.checkStickyScrollHeight(scrollTop);
    this.setState({ isHide: true });
    // 校验首页去登录按钮旁边是否显示去顶部的箭头
    // this.slidingToTopClipper({moveY: scrollTop, showDownBar});
    if (this.interval == null) {
      this.interval = setInterval(() => this.observeStop(this.containerDom.scrollTop), 500);
    } // 未发起时，启动定时器，1秒1执行
    if (scrollTop > 0) {
      const number = scrollTop > 420 ? 420 : scrollTop;
      const opacity = Math.floor(number) / 420;
      this.setState({ navbarOpacity: opacity, isShowFixBar: true });
    } else if (scrollTop == 0) {
      this.setState({ navbarOpacity: 0, isShowFixBar: false });
    } else {
      this.setState({ isShowFixBar: true });
    }
    this.stores.changeState({ scrollTop });

    // 调试：检查是否接近底部
    const { scrollTop: targetScrollTop, scrollHeight, clientHeight } = e.target;
    const distanceFromBottom = scrollHeight - targetScrollTop - clientHeight;

    // 接近底部时通知资格购列表加载更多
    if (distanceFromBottom < 200 && this.qualificationItemListRef) {
      this.qualificationItemListRef.loadMore();
    }
  };

  /**
   * 不带参数跳转页面
   */
  goPage = (url) => {
    if (!url) return;
    window.app.routerGoTo(url);
  };

  // 跳转到课程列表
  jumpCreamCourseList = (data) => {
    let oneTopic;
    let secTopic;
    if (data.parentId === 0) {
      oneTopic = data.id;
      secTopic = undefined;
    } else {
      oneTopic = data.parentId;
      secTopic = data.id;
    }
    window.app.routerGoTo({
      pathname: '/learn/thematic/class',
      state: {
        routers: [
          {
            key: data.id,
            title: data.name,
            index: 0,
            oneTopic, // 一级专题
            secTopic // 二级专题
          }
        ],
        index: 0,
        creamCourseName: data.name,
        isShowTabBar: false
      }
    });
  };

  dealSpecial5A = (goUrl = '/register/selectStoreType', { isPartner = false } = {}) => {
    const { userInfo } = this.appStore;
    const { userId, cardCode, phone } = userInfo || {};
    this.stores.getStoreTypeList(isPartner).then((storeList) => {
      if (storeList.length === 1) {
        const storeType = storeList[0] || {};
        const { id = '', typeName = '' } = storeType;
        // 请求是否开启了区域代理
        this.stores.getRegionConfiguration(id).then((data) => {
          if (!data.areaAgent) {
            // 一个店铺未开启区域代理，跳转到补充工作室信息页
            window.app.routerGoTo({
              pathname: '/register/storeCardMsg',
              clear: true,
              state: {
                userId,
                phone,
                cardCode,
                password: '*',
                noChange: true,
                storeTypeId: id, // 进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
                storeTypeName: typeName
              }
            });
          } else {
            // 一个店铺开启了区域代理，需跳转到选择店铺的页面
            window.app.routerGoTo({
              pathname: goUrl,
              search: Util.encodeQuery({
                storeTypeId: id, // 进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
                storeTypeName: typeName,
                grade: data.grade // 具体开了哪一级的代理 city市 province省  county区
              })
            });
          }
        });
      } else {
        // 多个店铺，跳转到选择店铺的页面
        window.app.routerGoTo({
          pathname: goUrl
        });
      }
    });
  };

  /**
   * 生命周期专题 + 跳转到我的权益 特殊处理 '#复消专区#','#升级恭贺礼#','#会员续约礼#'
   */
  lifeSpecialJudge = (data) => {
    const { userInfo, token } = this.appStore;
    const {
      cardCode,
      cardType,
      systemType,
      belongSystem,
      lifecycleTag,
      saleZone = ''
    } = userInfo || {};
    // 默认不拦截
    let flag = false;
    if (data.specialDescription === '权益中心') {
      // 登录用户的推荐位方案不一致
      // if (token && data.isDefaultProject == 0) {
      //   Toast.show('推荐位方案不一致！');
      //   return true;
      // }
      // 有无资格
      if (token && data.isLifeValid == 0) {
        let confirmText = '';
        let title = '';
        if (userInfo.memberStatus === 2) {
          // memberStatus 0 有效 1 未激活 2 未续约 3 已注销 4 冻结 5 休眠期
          confirmText = '去激活';
          title = '非常抱歉！您的会员资格已过期，无法享受该权益，尽快去激活享受吧！';
        } else if (
          cardType == -1 ||
          cardType === null ||
          userInfo.memberStatus === 1 ||
          (systemType === 1 && !lifecycleTag)
        ) {
          // systemType 0 三生体系 1 新零售
          // 普客/优惠顾客/未激活/非三生体系
          confirmText = '去升级';
          title = '叮咚！您暂时还无法享受该权益，尽快去升级享受吧！';
        }
        console.log('cardType>>>', cardType);
        if (title) {
          flag = true;
          this.stores.getRightsSetting().then((rightsList) => {
            window.sensors.track('userlifeCycle', {
              information_title: `权益中心-${confirmText}-弹窗`,
              type: 1, // type 1,2,3,4 区分点击、登录、注册、下单
              channal: 'H5',
              isLogin: !!token,
              userId: this.appStore.userInfo.id || '',
              cardCode: cardCode || ''
            });
            Modal.alert('温馨提示', title, [
              {
                text: '取消',
                onPress: () => {}
              },
              {
                text: confirmText,
                onPress: async () => {
                  if (confirmText == '去升级') {
                    if (saleZone) {
                      // 跳转消费专区
                      console.log('saleZone>>>', saleZone);
                      window.app.routerGoTo({
                        pathname: '/member/quickBuy',
                        state: {
                          globalSaleMode: 2
                        }
                      });
                    } else {
                      this.stores.applyNextUpgrade(null, {
                        inletTitle: `${data.specialDescription}-去升级`
                      });
                    }
                  } else if (confirmText == '去激活') {
                    const obj = (rightsList || []).find((item) => item.code == 'CZJHL');
                    if (obj && obj.specialPageId) {
                      window.app.routerGoTo({
                        pathname: `/shop/home/special/${obj.specialPageId}`,
                        state: {
                          inletTitle: `${data.specialDescription}-去激活`
                        }
                      });
                    }
                  }
                }
              }
            ]);
          });
        }
      }
    }
    return flag;
  };

  /**
   * 根据type跳转到目标页面
   */
  handleAction = async (data) => {
    const { userType, userInfo, token } = this.appStore;
    const { saleZone = '', memberStatus } = userInfo || {};
    console.log(data, 'homedatadata');
    // window.app.routerGoTo({
    //   pathname: '/shop/home/publicWelfareView'
    // });
    // return;
    const { qualificationList } = this.stores;
    const special = (data.content || '').indexOf('specialSortActivitityView') >= 0;
    if (!this.appStore.userInfo.token && data.id) {
      this.appStore.changeState('dojumpData', data.id);
    }

    if (data.id) {
      window.sensors.track('doJump', {
        recommend_id: data.id, // 推荐位id
        isLogin: !!this.appStore.userInfo.token,
        userId: this.appStore.userInfo.id || ''
      });
    }

    if (data && data.specialDescription === '健康家·幸福列车') {
      window.sensors.track('happyTrainSpecialPage', {
        information_title: data.specialDescription,
        special_page_id: data.content,
        channal: 'H5',
        isLogin: !!this.appStore.userInfo.token,
        userId: this.appStore.userInfo.id || '',
        cardCode: this.appStore.userInfo.cardCode || ''
      });
    }

    /**
     * @description 登录状态判断处理
     * @param {*} url
     */
    function commonHandle(url) {
      if (!token) {
        Util.setLocalCache(config.localStorageKeys.loginGoback, true); // 登录后是否返回指定页面的标识
        Util.setLocalCache(config.localStorageKeys.registerRoute, url); // 登录后是否返回指定页面的标识
        window.app.routerGoTo('/login');
      }
      return !token;
    }
    const strLinkBase = 'https://h5.yofogo.com/specialPage/';
    let search = {};
    switch (`${data.type}`) {
      case '0':
        // 啥都不做
        break;
      case '1':
        if (data.content === 'https://h5.yofogo.com/') {
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/share_card.jpg'
          });

          return;
        }
        if (data.content === 'https://h5.yofogo.com/weekYear') {
          // 周年庆
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/WeekYear/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/week-year/0117-1/share_card.png'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/weekYear1') {
          // 周年庆-YG
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/WeekYear/indexYG',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/week-year/0203/share_card.png'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/20230530') {
          // 嘉年华-20230530
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/20230530/Carnival/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/20230530/share_card.png'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/20230618') {
          // 芦荟胶-20230618
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/20230618/Carnival/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/20230618/share_card.png'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/20240416') {
          // 夏令营-20240416
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/20240416/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/yundian/assets/img/rankActivity/share.png'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/20240530') {
          // 嘉年华-20240530
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/20240530/Carnival/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/20240530/share_card.png'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/commonweal') {
          // 三生公益活动
          window.app.routerGoTo({
            pathname: '/shop/home/publicWelfareView'
          });
          return;
        }
        if (data.content === 'https://h5.yofogo.com/taiYearCard') {
          // 肽素乳畅享卡 有肽素乳畅享卡的权限并且下过订单才能进入肽素乳畅享卡页面
          if (!isHasRouteAuth(routeAuthCodeMap.PERSONAL_BATCH_ORDER)) {
            Toast.info('抱歉，您的肽素乳畅享卡权益不可用，详情可咨询客服');
            return;
          }
          this.appStore.getShowBatchOrder().then((data) => {
            if (data) {
              window.app.routerGoTo({
                pathname: '/personal/PeptideMilkAnnualPass'
              });
            } else {
              Toast.info('未查询到您购买过肽素乳畅享卡');
            }
          });
          return;
        }
        if (data.content.indexOf(strLinkBase) > -1) {
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: `pages/ThematicScreen/Special/index?id=${data.content.replace(strLinkBase, '')}`,
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/20241030/share_card.png'
          });
          return;
        }
        if (data.content.indexOf('https://h5.yofogo.com/videoPlayCheckIn') > -1) {
          // 视频打卡
          let speciald = Util.getParamsQueryString(data.content, 'speciald');
          window.app.routerGoTo(`/learn/videoPunch/index?id=${speciald}`);
          return;
        }
        if (data.content.indexOf('https://h5.yofogo.com/teamVideoPlayCheckIn') > -1) {
          // 团队打卡
          Modal.alert('温馨提示', '请到有享云商app进行操作');
          return;
        }
        if (data.content.indexOf('xverse.cn') > -1) {
          const { id, realName = '', phone = '', cardCode = '' } = userInfo || {};

          // 元宇宙
          if (!token || !userInfo) {
            window.app.routerGoTo('/login?sourceType=xverse');
            return;
          }
          localStorage.removeItem('sourceTypeParams');
          localStorage.removeItem('locationHrefParams');
          localStorage.removeItem('sourceXversePopup');
          let sign = hex_md5(
            `${id}${phone || ''}${cardCode || ''}${realName || ''}-${xverseParams}`
          ).toUpperCase();
          let url = `${data.content}?source=h5&userId=${id}&nickname=${realName || ''}&phone=${
            phone || ''
          }&cardCode=${cardCode || ''}&sign=${sign}`;

          window.location.href = url;
          return;
        }
        if (data.content === 'https://h5.yofogo.com/ranking') {
          if (!token || !userInfo) {
            Util.setLocalCache(config.localStorageKeys.loginGoback, true); // 登录后是否返回指定页面的标识
            Util.setLocalCache(config.localStorageKeys.registerRoute, `/shop/home/skRankingView`); // 登录后是否返回指定页面的标识
            window.app.routerGoTo('/login');
            return;
          }
          window.app.routerGoTo(`/shop/home/skRankingView`);
          return;
        }
        if (data.content.includes('sxyh5') || data.content.includes('study.huanongying.cn')) {
          // 商学院独立站点
          if (!token || !userInfo) {
            window.app.routerGoTo('/login');
            return;
          }
          let url = '';
          let r = '';
          if (data.content.includes('/#/')) {
            const arr = data.content.split('/#/');
            url = arr[0];
            r = arr[1];
          } else {
            url = data.content;
          }
          window.location.href = `${url}/#/home?n=${token}&d=${userInfo.id}&r=${r}`;
          return;
        }
        if (data.content === 'https://h5.yofogo.com/carRanking') {
          if (!token || !userInfo) {
            Util.setLocalCache(config.localStorageKeys.loginGoback, true); // 登录后是否返回指定页面的标识
            Util.setLocalCache(
              config.localStorageKeys.registerRoute,
              `/shop/home/skCarRankingView`
            ); // 登录后是否返回指定页面的标识
            window.app.routerGoTo('/login');
            return;
          }
          window.app.routerGoTo(`/shop/home/skCarRankingView`);
          return;
        }
        if (data.content.indexOf('lyBrightActionView') != -1) {
          const v = commonHandle('/shop/home/lyBrightActionView');
          if (v) return;
          window.app.routerGoTo(`/shop/home/lyBrightActionView`);
          return;
        }
        if (data.content.indexOf('ldMini') > -1) {
          // #region 跳转乐道小程序// 获取=之后的数据
          this.stores.syncLd().then((res) => {
            if (res) {
              try {
                // const idVal = res === true ? this.appStore.userInfo.cardCode || '' : res;
                // const v = `${data.content.split('=')[1]}?orderid=${idVal}`;
                // window.location.href = v;
                this.miniDateRef.current = goLdMiniProgram({ content: data.content }) || {};
                this.setState({ showMiniModal: true });
              } catch (error) {}
            }
          });
          return;
        }
        if (data.content && data.content.indexOf('recommender') > -1) {
          // 跳转推客小程序 http://recommender.com?type=tuike
          let jumpType = 1;
          if (data.content.indexOf('tuike') > -1) {
            jumpType = 2;
          }
          if (data.content.indexOf('daren') > -1) {
            jumpType = 3;
          }
          // 链商小程序
          if (Util.isWeiXin()) {
            this.stores.changeState({
              commenderJumpType: jumpType,
              showRecommenderWeapp: true,
              usernameStr: ghObj[`${Util.getQueryParams(data.content).name}`] || ''
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者有享小店再体验链商小程序！', 2);
          }
          return;
        }
        if (
          data.content &&
          data.content.indexOf('pages/ThematicScreen/WeekYear/indexCommon') > -1
        ) {
          // 2023年会
          if (Util.isWeiXin()) {
            this.setState({
              showCarnivalModal: true,
              showCarnivalWeapplUrl: data.content.replace('https://h5.com', ''),
              showCarnivalWeapplShareCard:
                'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/week-year/1107/share_card.png'
            });
          } else {
            Toast.info('跳转小程序，请在微信环境内打开', 2);
          }

          return;
        }
        // 跳转到蜂鸟
        if (
          data.content &&
          (data.content.indexOf('https://wd.yofopay.com') > -1 ||
            data.content.indexOf('https://wd.yofogo.com') > -1)
        ) {
          this.stores.jumpToFengniao(data.content);
          return;
        }
        if (/^(mpsxy):\/\//.test(data.content)) {
          const linkData = parseCustomLink(data.content, 'mpsxy');
          const { success, path: routePath } = linkData || {};
          if (success && routePath) {
            window.showMiniProgramModal({
              path: routePath,
              imgUrl:
                'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sxy_mini_program_image.png',
              username: 'gh_b5d04d764715'
            });
          }
          return;
        }
        if (/^(app|h5|pc|mp):\/\//.test(data.content)) {
          // 内部自定义链接
          const linkData = parseCustomLink(data.content, 'h5');
          const { success, path: routePath } = linkData || {};
          if (success && routePath) {
            window.app.routerGoTo(routePath);
          }
          return;
        }
        // 跳转到自定义链接
        window.location.href = special
          ? `${data.content}&t=${Math.random(10000) * 10000}`
          : data.content;
        break;
      case '2':
        // 跳转到产品详情
        window.app.routerGoTo({
          pathname: `/shop/productDetail/${data.content}`,
          state: { sourceTag: '首页' }
        });
        break;
      case '3': {
        // 根据id列表跳转到产品列表
        let contentInfo = '';
        let contentId = '';
        let searchParams = {};
        try {
          contentInfo = JSON.parse(data.content);
        } catch (e) {
          console.log('data.content err', e);
        }
        if (contentInfo.content) {
          const { content: id, ...otherParams } = contentInfo;
          contentId = id;
          searchParams = otherParams || {};
        } else {
          contentId = data.content;
        }
        // console.log('contentInfocontentInfo', contentInfo);
        // searchParams --> priceRangeS, priceRangeE, bvRangeS, bvRangeE, integralRangeS, integralRangeE
        // const { content: id,  ...searchParams} = contentInfo;
        const globalSaleMode = data.globalSaleMode;
        this.stores
          .checkFirstCateGory(contentId)
          .then((data) => {
            console.log('2121211', data);
            if (data.displayType == 1) {
              window.app.routerGoTo({
                pathname: `/shop/home/importantSeriesView/${data.id}`,
                state: {
                  dirId: data.id,
                  title: data.name,
                  sourceTag: '首页',
                  productParam: JSON.stringify({
                    globalSaleMode
                  })
                }
              });
            } else {
              // extension 层级类目
              if (data.extension === '1') {
                window.app.routerGoTo({
                  pathname: `/shop/home/productClassfiy/${contentId}`,
                  state: {
                    searchParams,
                    sourceTag: '首页',
                    dirId: data.id,
                    title: data.name
                  }
                });
              } else {
                window.app.routerGoTo({
                  pathname: '/shop/productList',
                  state: {
                    frontDirIdList: [contentId],
                    searchParams,
                    sourceTag: '首页'
                  }
                });
              }
            }
          })
          .catch((err) => {
            window.app.routerGoTo({
              pathname: '/shop/productList',
              state: {
                frontDirIdList: [contentId],
                searchParams,
                sourceTag: '首页'
              }
            });
          });
        break;
      }
      case '4':
        // 跳转到文章详情
        window.app.routerGoTo({
          pathname: `/shop/home/news/${data.content}`,
          state: { sourceTag: '首页' }
        });
        break;
      case '5':
        // 根据keyword跳转到产品列表
        window.app.routerGoTo({
          pathname: '/shop/productList',
          state: {
            sourceTag: '首页'
          },
          search: Util.encodeQuery({
            keyword: data.content
          })
        });
        break;
      case '6':
        // 促销活动跳转
        window.app.routerGoTo({
          pathname: `/shop/home/activity/normal/${data.content}`,
          state: { sourceTag: '首页' }
        });
        break;
      case '7':
        // 主题活动跳转
        window.app.routerGoTo({
          pathname: `/shop/home/activity/theme/${data.content}`,
          state: { sourceTag: '首页' }
        });
        break;
      case '8':
        if (this.lifeSpecialJudge(data)) {
          return;
        }
        // 专题跳转
        let url =
          data.extend == 1
            ? `/shop/home/specialProduct/${data.content}`
            : data.extend == 4
              ? `/shop/home/special/${data.content}`
              : `/shop/home/specialClassify/${data.content}`;
        // 九月开卡活动
        if (data.content === '1284572010394067054') {
          url = '/shop/home/landingPage';
        }

        // 乐道大单 1301971017715046475-59800乐道大单  1301970723709016081-29800乐道大单  1301971017715046475-49600乐道大单  1312637255001846898-3000乐道大单
        if (
          data.content === '1301971017715046475' ||
          data.content === '1301970723709016081' ||
          data.content === '1310775965653203001' ||
          data.content === '1312637255001846898'
        ) {
          url = `/shop/home/special/ldorder/${data.content}`;
        }
        if (data.content === '1284572010394067054' || data.content === '1289711559064730682') {
          Toast.info('请下载有享云商App体验');
          return;
        }
        // 国际版的 优享会拦截跳转并提示
        if (
          this.appStore.isInternationalized &&
          data.description &&
          data.description.includes('#优享会#')
        ) {
          Toast.info('抱歉，当前地区暂时不参与活动');
          return;
        }

        if (
          data.content === '1360220264662759427' ||
          data.content === '1360588115981565028' ||
          data.content === '1361221708027249750'
        ) {
          url = '/shop/home/firstClass';
        }
        // 三生豆商品列表
        if (data.extend == 8) {
          url = '/PunchClock/RecommendBeanList';

          search = Util.encodeQuery({
            recommendId: data.content
          });
        }

        window.app.routerGoTo({
          pathname: url,
          state: {
            inletTitle:
              (descriptionList.includes(data.specialDescription) && data.specialDescription) || '',
            sourceTag: '首页'
          },
          search: search
        });
        break;
      case '9':
        if (data.content == 'all') {
          // content 非id 接参数show不传1
          window.app.routerGoTo({
            pathname: `/shop/qualificationPage`,
            state: { sourceTag: '首页' }
          });
          return;
        }
        if (!this.appStore.token) {
          window.app.routerGoTo('/login');
          return;
        }
        // 资格购跳转
        // const qualification = qualificationList.find(
        //   item => item.id == data.content,
        // );
        // if (!qualification) {
        //   Toast.info('您没有当前活动资格');
        //   return;
        // }
        this.stores.jumpToLimitBuy({
          content: data.content,
          showFlag: true,
          qualificationList,
          sourceTag: '首页',
          globalSaleMode: data.globalSaleMode
        });
        break;
      case '10':
        const { content: contents } = data || {};
        const { route: routesValue, h5Link, id: idValue } = JSON.parse(contents || null) || {};
        console.log(data, 'datadatadatadatadatadatadata', contents, routesValue);

        if (routesValue == 'DietitianGuide') {
          window.app.routerGoTo({ pathname: '/promote/dietitianRegister/guide' });
          return;
        }

        if (routesValue == 'healthHome' || routesValue == 'Health') {
          Modal.alert('', '体验该功能请下载有享云商APP', [
            { text: '取消' },
            {
              text: '确定',
              onPress: () =>
                window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.yofoto.yofoys')
            }
          ]);
          return;
        }

        if (routesValue == 'FingerDetectionHome') {
          // AI指脉检测功能仅在app有，给出提示
          Toast.info('请下载有享云商APP后再进行AI指脉检测');
          return;
        }

        if (routesValue == 'SkinDetectionHome') {
          // AI皮肤检测功能仅在app有，给出提示
          Toast.info('请下载有享云商APP后再进行AI皮肤检测');
          return;
        }
        if (routesValue == 'SaleZone') {
          this.stores.jumpToSaleZone();
          return;
        }

        if (routesValue == 'pages/ApplyStoreScreen/StoreInfo/index') {
          // 跳转到小程序 如果未开店则跳申请开卡页面 已开卡则跳云店首页
          this.routesValue = routesValue;
          const { imgUrl } = data || {};
          this.showImgUrl = imgUrl;
          const { userInfo } = this.appStore || {};
          const { cstoreId } = userInfo || {};
          if (cstoreId) {
            if (Util.isWeiXin()) {
              this.setState({ showGoYundianOpenShop: true });
            } else {
              Toast.info('跳转小程序，请在微信环境内打开', 2);
            }
          }
          return;
        }

        if (data.content == 'openCard') {
          if (!this.appStore.token) {
            window.app.routerGoTo('/login');
            return;
          }
          if (this.appStore.userInfo.userType > 1) {
            Toast.info('您已是会员');
            return;
          }
          this.stores.queryCanApplyType();
        } else if (['ApplyOpenShopMap', 'ApplyOpenShop'].includes(routesValue)) {
          const is5ANormal = userInfo.belongSystem == 'WLM' && userInfo.userType == 1;
          const isGoMap = routesValue == 'ApplyOpenShopMap';
          const goUrl = isGoMap ? '/map/storeSetup' : '/register/selectStoreType';
          if (!token || !userInfo) {
            window.app.routerGoTo('/login');
            return;
          }
          if (isGoMap) {
            const { data: lianChuangData } = (await this.stores.checkLianChuangProxy(true)) || {};
            const {
              isOpenProxy = 0, // 体系是否可以开通代理 0 体系未开通代理 1 体系可以开通代理
              lianChuangMember = 0, // 会员是否是联创会员 0 非联创会员 1联创会员
              openLianChuangStore = 0 // 会员是否已开通联创门店 0 未开通 1已开通
            } = lianChuangData || {};
            if (lianChuangMember == 0) {
              Toast.info('您还不是联创合伙人');
              return;
            }
          }

          // 特殊逻辑 5A体系 普客 写死逻辑
          if (is5ANormal) {
            this.dealSpecial5A(goUrl, { isPartner: isGoMap });
            return;
          }
          if (
            userInfo.identityCard === null ||
            userInfo.identityCard === undefined ||
            userInfo.identityCard === ''
          ) {
            Modal.alert(
              '温馨提示',
              '暂未完善资料，请先完善资料后再申请开通工作室。对您造成的不便，敬请谅解！',
              [
                { text: '取消' },
                {
                  text: '完善资料',
                  onPress: () => {
                    window.app.routerGoTo({
                      pathname: '/personal/msgAdd',
                      clear: true,
                      state: {
                        target: '/register/studioMsg',
                        goUrl,
                        showBack: isGoMap,
                        isPartner: isGoMap,
                        params: {
                          clear: true
                        },
                        data: {
                          applyShopInfo: { userType },
                          localCardCode: userType == 2 ? userInfo.cardCode : ''
                        }
                      }
                    });
                  }
                }
              ]
            );
          } else {
            // registerType = 1，代表是“已注册”申请开店(0代表未注册开店)
            Util.setLocalCache(config.localStorageKeys.member_applyStoreMsg, {
              registerCardReqDto: {
                ...userInfo,
                saleConsultantNum: userInfo.saleConsultantCardCode
              },
              registerType: 1
            });
            this.stores.verifyMemberCardValidV2(isGoMap).then(({ data, resultMsg } = {}) => {
              if (data) {
                // if(+userType === 1 ){
                this.appStore.saveLoginInfo(data);
                Util.setLocalCache(config.localStorageKeys.member_applyStoreMsg, {
                  registerCardReqDto: {
                    ...data,
                    // 健康顾问字段key重新赋值，
                    // saleConsultantNum: this.appStore.AppMod.userInfo.saleConsultantCardCode,
                    // password: rstr2b64('*'),
                    // 生日必须将时分秒去掉，格式化为年月日，否则后台会出现错误
                    birthday: data.birthday ? dayjs(data.birthday).format('YYYY-MM-DD') : ''
                  },
                  // registerType = 1，代表是“已注册”申请开店(0代表未注册开店)
                  registerType: 1
                });
                // }
                // 只有一个店铺类型可用且没开通区域代理，直接跳转到补充工作室信息页面，再跳转到礼包的时候要直接带上唯一店铺，并且不可切换
                // 多个店铺的时候要跳转到选择店铺类型的页面，选择后跳转到补充工作室信息页面，再跳转到礼包的时候要直接带上选择的店铺，并且不可切换
                this.stores.getStoreTypeList(isGoMap).then((storeList) => {
                  if (storeList.length === 1) {
                    const storeType = storeList[0] || {};
                    const { id = '', typeName = '' } = storeType;

                    // 请求是否开启了区域代理
                    this.stores.getRegionConfiguration(id).then((data) => {
                      if (!data.areaAgent) {
                        // 一个店铺未开启区域代理，跳转到补充工作室信息页
                        window.app.routerGoTo({
                          pathname: '/register/studioMsg',
                          clear: true,
                          state: {
                            showBack: true,
                            storeTypeId: id, // 进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
                            storeTypeName: typeName
                          }
                        });
                      } else {
                        // 一个店铺开启了区域代理，需跳转到选择店铺的页面
                        window.app.routerGoTo({
                          pathname: goUrl,
                          state: {
                            showBack: true
                          },
                          search: Util.encodeQuery({
                            storeTypeId: id, // 进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
                            storeTypeName: typeName,
                            grade: data.grade // 具体开了哪一级的代理 city市 province省  county区
                          })
                        });
                      }
                    });
                  } else {
                    // 多个店铺，跳转到选择店铺的页面
                    window.app.routerGoTo({
                      pathname: goUrl,
                      state: {
                        showBack: true
                      }
                    });
                  }
                });
              } else {
                isGoMap &&
                  resultMsg &&
                  window.app.routerGoTo({
                    pathname: goUrl,
                    state: {
                      showBack: true,
                      tips: resultMsg
                    }
                  });
              }
            });
          }

          // 开卡升级指定卡类型
        } else if (routesValue == 'OpenCard') {
          // 配置跳转到升级开卡选购礼包界面
          this.stores.applyNextUpgrade(idValue);
        } else if (routesValue == '/promote/equity') {
          const { userInfo, token } = this.props.AppMod;
          const { id: userId, cardCode } = userInfo || {};
          window.sensors.track('userlifeCycle', {
            information_title: '权益中心',
            type: 1, // type 1,2,3,4 区分点击、登录、注册、下单
            channal: 'H5',
            isLogin: !!token,
            userId: userId || '',
            cardCode: cardCode || ''
          });
          if (
            this.lifeSpecialJudge({
              ...data,
              specialDescription: '权益中心'
            })
          ) {
          } else {
            window.app.routerGoTo({ pathname: routesValue, state: { sourceTag: '首页' } });
          }
        } else if (routesValue == 'CouponList') {
          // 优惠券列表
          window.app.routerGoTo('/member/wallet/coupon');
        } else if (routesValue == 'YofotoBeanMall') {
          // 三生豆商城
          Modal.alert(
            '温馨提示',
            '为了给您提供更流畅的体验，建议您打开我们的“有享云商”APP完成此操作。感谢您的配合！',
            [
              {
                text: '我已知晓',
                onPress: async () => {}
              }
            ]
          );
          // Toast.info('请前往有享云商APP查看喔～');
        } else if (routesValue == 'FastShopping' || h5Link == 'FastShopping') {
          // 升级
          window.app.routerGoTo({
            pathname: '/member/quickBuy',
            state: {
              sourceTag: '首页'
            }
          });
        } else if (data.content) {
          const contentObj = JSON.parse(data.content);
          let route = contentObj.route || contentObj.h5Link;
          const id = contentObj.id || contentObj.detailId;
          if (route == 'ApplyOpenShop') {
            const is5ANormal = userInfo.belongSystem == 'WLM' && userInfo.userType == 1;
            if (!token || !userInfo) {
              window.app.routerGoTo('/login');
              return;
            }
            // 特殊逻辑 5A体系 普客 写死逻辑
            if (is5ANormal) {
              this.dealSpecial5A();
              return;
            }
            if (
              userInfo.identityCard === null ||
              userInfo.identityCard === undefined ||
              userInfo.identityCard === ''
            ) {
              Modal.alert(
                '温馨提示',
                '暂未完善资料，请先完善资料后再申请开通工作室。对您造成的不便，敬请谅解！',
                [
                  { text: '取消' },
                  {
                    text: '完善资料',
                    onPress: () => {
                      window.app.routerGoTo({
                        pathname: '/personal/msgAdd',
                        clear: true,
                        state: {
                          target: '/register/studioMsg',
                          params: {
                            clear: true
                          },
                          data: {
                            applyShopInfo: { userType },
                            localCardCode: userType == 2 ? userInfo.cardCode : ''
                          }
                        }
                      });
                    }
                  }
                ]
              );
            } else {
              // registerType = 1，代表是“已注册”申请开店(0代表未注册开店)
              Util.setLocalCache(config.localStorageKeys.member_applyStoreMsg, {
                registerCardReqDto: {
                  ...userInfo,
                  saleConsultantNum: userInfo.saleConsultantCardCode
                },
                registerType: 1
              });
              this.stores.verifyMemberCardValid().then((data) => {
                if (data) {
                  // if(+userType === 1 ){
                  this.appStore.saveLoginInfo(data);
                  Util.setLocalCache(config.localStorageKeys.member_applyStoreMsg, {
                    registerCardReqDto: {
                      ...data,
                      // 健康顾问字段key重新赋值，
                      // saleConsultantNum: this.appStore.AppMod.userInfo.saleConsultantCardCode,
                      // password: rstr2b64('*'),
                      // 生日必须将时分秒去掉，格式化为年月日，否则后台会出现错误
                      birthday: data.birthday ? dayjs(data.birthday).format('YYYY-MM-DD') : ''
                    },
                    // registerType = 1，代表是“已注册”申请开店(0代表未注册开店)
                    registerType: 1
                  });
                  // }

                  // 只有一个店铺类型可用且没开通区域代理，直接跳转到补充工作室信息页面，再跳转到礼包的时候要直接带上唯一店铺，并且不可切换
                  // 多个店铺的时候要跳转到选择店铺类型的页面，选择后跳转到补充工作室信息页面，再跳转到礼包的时候要直接带上选择的店铺，并且不可切换
                  this.stores.getStoreTypeList().then((storeList) => {
                    if (storeList.length === 1) {
                      const storeType = storeList[0] || {};
                      const { id = '', typeName = '' } = storeType;
                      // 请求是否开启了区域代理
                      this.stores.getRegionConfiguration(id).then((data) => {
                        if (!data.areaAgent) {
                          // 一个店铺未开启区域代理，跳转到补充工作室信息页
                          window.app.routerGoTo({
                            pathname: '/register/studioMsg',
                            clear: true,
                            state: {
                              storeTypeId: id, // 进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
                              storeTypeName: typeName
                            }
                          });
                        } else {
                          // 一个店铺开启了区域代理，需跳转到选择店铺的页面
                          window.app.routerGoTo({
                            pathname: '/register/selectStoreType',
                            search: Util.encodeQuery({
                              storeTypeId: id, // 进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
                              storeTypeName: typeName,
                              grade: data.grade // 具体开了哪一级的代理 city市 province省  county区
                            })
                          });
                        }
                      });
                    } else {
                      // 多个店铺，跳转到选择店铺的页面
                      window.app.routerGoTo({
                        pathname: '/register/selectStoreType'
                      });
                    }
                  });
                }
              });
            }
            return;
          }
          if (route == '/personal/QuestionnaireView') {
            const data = await this.appStore.checkGoto(contentObj.id);
            // console.log('datadatadata',data)
            if (data.data.isSucc == 0) {
              Toast.info(data.data.result);
              return;
            }
          }
          if (!this.appStore.token && route != '/personal/QuestionnaireView') {
            // 线下活动详情
            if (route === '/promote/offlineActivity/activityDetail') {
              localStorage.setItem('decoratorBackHref', `${route}?id=${id}`);
            }
            window.app.routerGoTo('/login');
            return;
          }

          if (
            route === 'Livebroadcast' ||
            route === 'liveRoom' ||
            route === 'CstoreLivebroadcast' ||
            route === 'CstoreLiveRoom'
          ) {
            let roomId = '';
            if (Util.isValidJSON(data.content)) {
              let roomContent = JSON.parse(data.content);
              roomId = roomContent.id || roomContent.detailId;
            }
            let isCstore = route == 'CstoreLivebroadcast' || route == 'CstoreLiveRoom'; // 是否云小店直播相关
            // 微信环境打开小程序弹窗

            console.log(roomId, 'roomid');
            if (Util.isWeiXin()) {
              let newImgUrl = data.imgUrl;
              if (data.imgUrl) {
                const isJsonSting = (str) => {
                  try {
                    const toObj = JSON.parse(str);
                    if (toObj && typeof toObj === 'object') {
                      return true;
                    }
                  } catch (error) {
                    return false;
                  }
                };
                if (isJsonSting(data.imgUrl)) {
                  const imgUrlData = JSON.parse(data.imgUrl) || {};
                  newImgUrl = imgUrlData.imgUrl || '';
                }
              }
              console.log('微信环境打开小程序弹窗');
              // 微信环境打开小程序弹窗
              this.stores
                .getLiveList()
                .then((res) => {
                  Toast.hide();
                  console.log('resres直播', res);
                  if (res && res.length > 0) {
                    let result = res.find((item) => item.roomid == roomId);
                    if (result) {
                      // 取列表图片
                      this.stores.changeState({
                        liveRoomId: roomId || '',
                        showWeappModal: true,
                        liveCoverUrl: result.share_img || '',
                        wechatAppid: isCstore ? 'gh_825754bbda7f' : 'gh_62517e9b6920'
                      });
                    } else {
                      // 默认图片
                      this.stores.changeState({
                        liveRoomId: roomId || '',
                        showWeappModal: true,
                        liveCoverUrl: data.imgUrlApp || newImgUrl || '',
                        wechatAppid: isCstore ? 'gh_825754bbda7f' : 'gh_62517e9b6920'
                      });
                    }
                  }
                })
                .catch((err) => {
                  // 默认图片
                  this.stores.changeState({
                    liveRoomId: roomId || '',
                    showWeappModal: true,
                    liveCoverUrl: data.imgUrlApp || newImgUrl || '',
                    wechatAppid: isCstore ? 'gh_825754bbda7f' : 'gh_62517e9b6920'
                  });
                });
            } else {
              Toast.info('请登录有享云商APP观看直播！', 2);
            }
            return;
          }

          // 跳转三生素材库页面
          if (route === 'SanshengMaterial') {
            if (Util.isWeiXin()) {
              this.stores.changeState({
                showWeappModalMore: true,
                target: 'sanshengMaterial',
                targetRoute: id || ''
              });
            } else {
              Toast.info('请搜索“三生素材库”小程序查看素材', 2);
            }
            return;
          }

          if (id && route) {
            if (route == '/learn/thematic/class') {
              this.stores.getThematicDetail({ id }).then((data) => {
                if (data) {
                  if (data.typeLevel === 1) {
                    // 一级专题跳转到详情页
                    this.jumpCreamCourseList(data);
                  } else if (data.typeLevel === 2) {
                    // // parentId大于0就跳课程列表，parentId等于0就跳专题列表
                    // if (Number(data.parentId) > 0) {
                    //   this.jumpCreamCourseList(data);
                    // } else if (Number(data.parentId) == 0) {
                    const params = { title: data.name };

                    if (data.parentId === 0) {
                      params.oneTopic = data.id;
                      params.secTopic = null;
                    } else {
                      params.oneTopic = data.parentId;
                      params.secTopic = data.id;
                    }
                    window.app.routerGoTo({
                      pathname: `/learn/thematic/detail/${data.id}`,
                      state: params
                    });
                    // }
                  } else if (data.typeLevel === 3) {
                    window.app.routerGoTo({
                      pathname: '/learn/PromotionTree/PromotionTreeView',
                      search: Util.encodeQuery({
                        thematicId: data.id
                      })
                    });
                  }
                }
              });
              return;
            }

            // 培训中心-工具流 抖音页面
            if (route == '/learn/tools/ToolVideo') {
              this.props.AppMod.changeState('fromHome', true);
              window.app.routerGoTo({
                pathname: '/learn/tools/ToolsView',
                state: {
                  thematicId: id,
                  initialSlide: 0
                }
              });
              return;
            }

            // 培训中心-工具流专题
            if (route == '/learn/tools/ToolsView') {
              this.props.AppMod.changeState('fromHome', true);
              // window.app.routerGoTo(`${route}?thematicId=${id}`);
              window.app.routerGoTo({
                pathname: '/learn/tools/ToolsView',
                state: {
                  thematicId: id,
                  initialSlide: 1
                }
              });
              return;
            }

            // 线下活动详情
            if (route === '/promote/offlineActivity/activityDetail') {
              this.props.AppMod.meetValidate(id).then((data) => {
                if (data) {
                  window.app.routerGoTo(`${route}?id=${id}`);
                } else {
                  Toast.info('暂无资格参与');
                }
              });
              return;
            }

            // 学习地图
            if (route === 'LearningMap') {
              window.app.routerGoTo({
                pathname: '/learn/PromotionTree/PromotionTreeView',
                search: Util.encodeQuery({
                  thematicId: id
                })
              });
              return;
            }

            window.app.routerGoTo(`${route}?id=${id}`);
            return;
          }

          if (route) {
            // if (route === '/learn/finding') {
            // 处理返回目标页
            this.props.AppMod.changeState('fromHome', true);
            // }
            // 培训中心工具流-首页
            if (route == '/learn/tools/ToolsView/ToolsThematic') {
              this.props.AppMod.changeState('fromHome', true);
              // window.app.routerGoTo(`${route}?thematicId=${id}`);
              window.app.routerGoTo({
                pathname: '/learn/tools/ToolsView',
                state: {
                  initialSlide: 1,
                  isHome: true
                }
              });
              return;
            }
            window.app.routerGoTo(route);
          }
        }
        break;
      case '12':
        // 跳转到排行榜活动
        window.app.routerGoTo({
          pathname: '/shop/home/sortActivityView',
          search: Util.encodeQuery({
            keyword: data.content
          })
        });
        break;
      case '16':
        if (Util.isWeiXin()) {
          console.log('微信环境打开小程序弹窗');
          // 微信环境打开小程序弹窗
          this.stores.changeState({
            weappChatAddId: data.content || '',
            showWeappModalAdd: true
          });
        } else {
          Toast.info('请登录有享云商APP添加企业微信！', 2);
        }
        break;
      case '18':
        // 1逛素材2享咨询3云逛逛4官方咨询
        const obj = data.content && typeof data.content === 'string' && JSON.parse(data.content);
        console.log(data, 'dddddaaa', obj);

        if (data.name == '官方资讯' || obj.articleCategoryNo == 4) {
          window.app.routerGoTo({
            pathname: `/shop/home/officialInformation`,
            state: {
              articleTypeId: obj.articleTypeId
            }
          });
          return;
        }

        if (!data.indAdvPicture) {
          // 广告图
          data.indAdvPicture = '';
        }

        if (
          obj.articleCategoryNo == 1 ||
          data.name == '逛素材' ||
          obj[`articleCategoryNo${data.indAdvPicture}`] == 1
        ) {
          window.app.routerGoTo({
            pathname: `/shop/guang`,
            state: {
              articleTypeId: obj.articleTypeId || obj[`articleTypeId${data.indAdvPicture}`],
              titleName: '逛素材'
            }
          });
          return;
        }

        if (
          obj.articleCategoryNo == 3 ||
          data.name == '云逛逛' ||
          obj[`articleCategoryNo${data.indAdvPicture}`] == 3
        ) {
          window.app.routerGoTo({
            pathname: `/shop/guang`,
            state: {
              articleTypeId: obj.articleTypeId || obj[`articleTypeId${data.indAdvPicture}`],
              titleName: '云逛逛'
            }
          });
          return;
        }

        const { news } = this.props.ShopHomeMod;
        obj.articleTypeId &&
          news &&
          news.length > 0 &&
          window.app.routerGoTo({
            pathname: '/shop/home/news',
            state: {
              articleTypeId: obj.articleTypeId
            }
          });
        break;
      case '20':
        window.app.routerGoTo({
          pathname: '/personal/SelectMallHomeView'
        });
        break;
      case '21':
        Modal.alert('温馨提示', '请打开有享云商APP关注公众号');
        break;
      case '23':
        const { content: contentPath } = data || {};
        if (Util.isWeiXin()) {
          this.stores.changeState({
            showWeappModal: true,
            curType: '23',
            pathContent: contentPath || '',
            wechatAppid: 'gh_62517e9b6920'
          });
        } else {
          Toast.info('请登录有享云商APP查看！', 2);
        }
        break;
      case '24':
        if (!token || !userInfo) {
          Util.setLocalCache(config.localStorageKeys.loginGoback, true); // 登录后是否返回指定页面的标识
          // offlineActivityId 区分活动中心
          Util.setLocalCache(
            config.localStorageKeys.registerRoute,
            `/promote/offlineActivity/activityDetail?offlineActivityId=${data.content}`
          ); // 登录后是否返回指定页面的标识
          window.app.routerGoTo('/login');
          return;
        }
        this.props.AppMod.meetValidate(data.content).then((resData) => {
          if (resData) {
            window.app.routerGoTo(`/promote/offlineActivity/activityDetail?id=${data.content}`);
          } else {
            Toast.info('暂无资格参与');
          }
        });
        break;
      case '30': // 资格购产品
        window.app.routerGoTo({
          pathname: `/shop/productDetail/${data.itemId}`,
          search: Util.encodeQuery({
            activityId: data.content,
            activityType: 10
          })
        });
        break;
      case '31': // 促销活动产品
        window.app.routerGoTo({
          pathname: `/shop/specialProductDetail/${data.itemId}`,
          search: Util.encodeQuery({
            activityId: data.content
          })
        });
        break;
      case '38': // 跳转小程序
        // 如果未登录先走登录
        if (!token) {
          window.app.routerGoTo('/login');
          return;
        }
        if (data.content === 'recommender') {
          // 链商小程序
          if (Util.isWeiXin()) {
            this.stores.changeState({ showRecommenderWeapp: true });
            return;
          } else {
            Toast.info('请登录有享云商APP或者有享小店再体验链商小程序！', 2);
          }
        } else if (data.content === 'SanshengMaterial') {
          // 三生素材库
          if (Util.isWeiXin()) {
            showToWeapp({
              icon: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sanshengMaterial_icon.png',
              path: '/pages/index/index',
              username: 'gh_ca6449f8285c'
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者三生素材库再体验小程序！', 2);
          }
        } else if (data.content === 'SanshengBusinessMaterial') {
          // 三生事业素材库
          if (Util.isWeiXin()) {
            showToWeapp({
              icon: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sanshengBusinessMaterial_icon.png',
              path: '/pages/index/index',
              username: 'gh_d431d44775b7'
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者三生素材库再体验小程序！', 2);
          }
        } else if (data.content === 'SbnMaterial') {
          // 视百年素材库
          if (Util.isWeiXin()) {
            showToWeapp({
              icon: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sbnMaterial_icon.png',
              path: '/pages/index/index',
              username: 'gh_676dfde0879c'
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者视百年素材库再体验小程序！', 2);
          }
        }
        break;
      case '81': // 销售专区
        this.stores.jumpToSaleZone();
        break;
      case '82': // 全部产品分类
        // 未登录时跳转至登录页
        if (!this.appStore.token) {
          window.app.routerGoTo('/login');
          return;
        }
        // 各个功能点击次数统计埋点
        this.tranckFunctionClick('分类', 'CLASSIFICATION_ICON');
        window.app.routerGoTo({
          pathname: '/shop/QuickProductList',
          state: {
            sourceTag: '首页'
          }
        });
        break;
      // 复消自选
      case '83': {
        if (!this.appStore.token) {
          window.app.routerGoTo('/login');
          return;
        }
        const distributionRatioList = this.appStore.userInfo.distributionRatioList || {};
        const defaultDisRadioList = (distributionRatioList[2] || []).sort(
          (a, b) => a.value - b.value
        );

        window.app.routerGoTo({
          pathname: '/member/quickBuy',
          state: {
            defaultOrderType: 2,
            defaultDisRadio: (defaultDisRadioList[0] && defaultDisRadioList[0].value) || ''
          }
        });
        break;
      }

      case '70': // AI展业星球
        Toast.info('请下载有享云商APP后再开启AI展业星球体验');
        break;
      case '71': // 数字人首页
        Toast.info('请下载有享云商APP进行数字人视频创作');
        break;
      case '72': // 创建数字人
        Toast.info('请下载有享云商APP后再创建数字人');
        break;
      case '73': // 个体户注册
        this.stores.changeState({
          showApply: true
        });
        break;
    }
  };

  handerNotice = (id, type) => {
    const { id: userId, cardCode } = this.appStore.userInfo || {};
    window.sensors.track('otherRecommend', {
      information_title: '复消悬浮条',
      type: 1,
      scene: type,
      channal: 'H5',
      recommend_id: id,
      userId,
      cardCode
    });
    let url = `/shop/home/special/${id}`;
    window.app.routerGoTo({
      pathname: url,
      state: {
        inlet: `${type}复消悬浮条`
      }
    });
  };

  // 跳转小程序弹窗-直播
  renderWeappModal = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const isProd = config.HOST === 'PROD';
    const userId = this.props.AppMod.userInfo.id || '';
    const { liveRoomId, liveCoverUrl, wechatAppid = '', curType, pathContent } = this.stores;
    let customParams = encodeURIComponent(
      JSON.stringify({ cardCode: this.appStore.userInfo && this.appStore.userInfo.cardCode })
    );
    const openPath =
      curType === '23'
        ? pathContent
        : `/__plugin__/wx2b03c6e691cd7370/pages/live-player-plugin?room_id=${liveRoomId}&custom_params=${customParams}`;

    return (
      <Modal title="" wrapClassName="posterModal" transparent visible={this.stores.showWeappModal}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <div style={{ width: '100%' }}>
            <wx-open-launch-weapp
              id="launch-btn"
              username={wechatAppid}
              path={
                // `/pages/ThematicScreen/Special/index?id=${specialId}`
                // `/pages/UserScreen/WebView/liveJump?id=${liveRoomId}`
                openPath
              }
              // env-version={isProd ? 'release' : "trial"}
            >
              <script type="text/wxtag-template">
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  {
                    <img
                      src={
                        curType == 23
                          ? modal_fnbl_program_image
                          : modal_mini_program_image || liveCoverUrl
                      }
                      style={{
                        width: '540px',
                        height: 'auto'
                      }}
                    />
                  }
                </div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              this.stores.changeState({
                showWeappModal: false,
                liveRoomId: '',
                liveCoverUrl: '',
                wechatAppid: 'gh_62517e9b6920',
                curType: ''
              });
            }}
          />
        </div>
      </Modal>
    );
  };

  // 跳转小程序弹窗-添加企微
  renderWeappModalAdd = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const isProd = config.HOST === 'PROD';
    const userId = this.props.AppMod.userInfo.id || '';
    const { weappChatAddId } = this.stores;
    return (
      <Modal
        title=""
        wrapClassName="posterModal"
        transparent
        visible={this.stores.showWeappModalAdd}
        maskClosable
        onClose={() => this.stores.changeState({ showWeappModalAdd: false, weappChatAddId: '' })}
        style={{ width: 600 }}>
        <div className="weappModal">
          <div>
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_825754bbda7f"
              path={`/pages/HomeScreen/index?pageType=enterWeChatAdd&itemId=${weappChatAddId}`}
              env-version={isProd ? 'release' : 'trial'}>
              <script type="text/wxtag-template">
                <div
                  className="buttonModal1"
                  style={{
                    width: '300px',
                    height: '120px',
                    background: '#ffffff',
                    'border-radius': '20px',
                    display: 'flex',
                    'align-items': 'center',
                    'justify-content': 'center',
                    'font-size': '32px'
                  }}>
                  在线咨询
                </div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              this.stores.changeState({ showWeappModalAdd: false });
            }}
          />
        </div>
      </Modal>
    );
  };

  // 跳转小程序弹窗-申请开店
  renderGoToOpenShopModal = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const isProd = config.HOST === 'PROD';
    const { weappChatAddId } = this.stores;
    let imgUrlShow = '';
    try {
      const isJson = Util.isJSON(this.showImgUrl);
      if (isJson) {
        const { imgUrl } = (isJson && JSON.parse(this.showImgUrl || null)) || {};
        imgUrlShow = imgUrl;
      }
    } catch (error) {}
    return (
      <Modal
        title=""
        wrapClassName="posterModal"
        transparent
        visible={this.state.showGoYundianOpenShop}
        maskClosable
        onClose={() => this.setState({ showGoYundianOpenShop: false })}>
        <div className="weappModal">
          <div>
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_825754bbda7f"
              path="/pages/HomeScreen/index"
              env-version={isProd ? 'release' : 'trial'}>
              <script type="text/wxtag-template">
                <img
                  src={modal_mini_program_image || imgUrlShow || this.showImgUrl}
                  style={{ width: '540px', height: 'auto' }}
                />
              </script>
            </wx-open-launch-weapp>
          </div>
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              this.setState({ showGoYundianOpenShop: false });
            }}
          />
        </div>
      </Modal>
    );
  };

  // 跳转小程序
  renderWeappTag = () => {
    const { target, targetRoute } = this.stores;
    // 三生素材库
    if (target == 'sanshengMaterial') {
      return (
        <div>
          <wx-open-launch-weapp
            id="launch-btn"
            username="gh_ca6449f8285c"
            path={`/${targetRoute || `pages/index/index`}`}>
            <script type="text/wxtag-template">
              <div
                style={{
                  // width: '594px',
                  width: '100%',
                  height: '192px',
                  background: '#fff',
                  'border-radius': '4px',
                  display: 'flex',
                  'align-items': 'center',
                  'justify-content': 'space-between'
                  // padding: '32px'
                }}>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '32px' }}>
                  <img style={{ width: '132px', height: '128px' }} src={SANSICON} />
                  <div style={{ fontSize: '32px', lineHeight: '44px', marginLeft: '24px' }}>
                    进入素材库
                  </div>
                </div>
                <div
                  style={{
                    width: '176px',
                    height: '68px',
                    background: '#fff3f5',
                    borderRadius: '36px',
                    textAlign: 'center',
                    fontSize: '32px',
                    lineHeight: '68px',
                    color: '#F01B3F',
                    marginleft: '12px',
                    marginRight: '24px'
                  }}>
                  点击进入
                </div>
              </div>
            </script>
          </wx-open-launch-weapp>
        </div>
      );
    }
  };
  // 跳转小程序弹窗
  renderWeappModalMore = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const { showWeappModalMore } = this.stores;
    return (
      <Modal
        title=""
        wrapClassName="posterModal"
        transparent
        visible={showWeappModalMore}
        maskClosable
        onClose={() => this.stores.changeState({ showWeappModalMore: false })}>
        <div className="weappModal">
          {this.renderWeappTag()}
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              this.stores.changeState({ showWeappModalMore: false });
            }}
          />
        </div>
      </Modal>
    );
  };

  /**
   * 加入购物车
   */
  addCart = async (info) => {
    const params = {
      itemName: info.itemName,
      itemNum: 1,
      itemSerial: info.itemId,
      skuSerial: info.skuId,
      price: info.price
    };

    const result = await addCartUtil(params);
    if (result) {
      Toast.info('加入购物车成功', 2);
    }
  };

  /**
   * 跳转搜索
   */
  goSearch = () => {
    window.app.routerGoTo({
      pathname: '/shop/search',
      state: {
        path: '/shop/productList',
        cancelPath: '/',
        sourceTag: '首页'
      }
    });
  };

  handleSize = (index, combinationType, imgInfo) => {
    const clientWidth = document.documentElement.clientWidth || 750;
    // 图片 169/91-对称宫格 169/143-不对称宫格1大图 169/68-不对称宫格1小图  169/207-不对称宫格2大图 169/100-不对称宫格2小图 69/20-横向宫格
    const rate = floatTool.divide(169, 91); // 宽高比
    const tmpW = clientWidth - 30 * 2 - 14;
    const imgW = tmpW / 2;
    let boxW = imgW;
    let boxH = imgW / rate;
    let spacing = 14;
    combinationType == 2 && (spacing = 18);
    let marginTop = combinationType
      ? index === 2
        ? spacing
        : 0
      : index == 0 || index == 1
        ? 0
        : spacing;

    let marginRight = index % 2 == 0 ? spacing : 0;

    let size = {
      boxW,
      boxH,
      marginTop,
      marginRight
    };

    switch (combinationType) {
      case 1: // 横向宫格
        const { width: $width, height: $height } = imgInfo || {};
        const imgW = clientWidth - 30 * 2;
        const rate1 = $width / $height;
        // const rate1 = 69 / 20;
        const imgH1 = imgW / rate1;
        size.boxW = imgW;
        size.boxH = imgH1;
        size = {
          boxW: imgW,
          boxH: imgH1,
          marginTop: 0
        };
        break;
      case 2: // 不对称宫格1
        const imgW1 = (clientWidth - 30 * 2 - 14) / 2;
        // const rate2 = index ? floatTool.divide(169, 68) : floatTool.divide(169, 143);
        const rate2 = index ? floatTool.divide(171, 81) : floatTool.divide(169, 169);
        const imgH2 = floatTool.divide(imgW1, Number(rate2.toFixed(2)));
        size.boxH = imgH2;
        if (index == 2) {
          size.marginRight = 0;
        }
        break;
      case 3: // 不对称宫格2
        const imgW2 = (clientWidth - 30 * 2 - spacing) / 2;
        const rate3 = index ? floatTool.divide(169, 100) : floatTool.divide(169, 207);
        const imgH3 = floatTool.divide(imgW2, rate3);
        size.boxH = imgH3;
        if (index == 2) {
          size.marginRight = 0;
        }
        break;
    }
    return size;
  };

  // 分类
  renderClassifyContent = () => {
    if (this.props.AppMod.token && !isHasRouteAuth(routeAuthCodeMap.CLASSIFICATION_ICON))
      return null;

    return (
      <div
        className={styles.navLeft}
        onClick={() => {
          // 未登录时跳转至登录页
          if (!this.props.AppMod.token) {
            window.app.routerGoTo('/login');
            return;
          }
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick('分类', 'CLASSIFICATION_ICON');
          window.app.routerGoTo({
            pathname: '/shop/QuickProductList',
            state: {
              sourceTag: '首页'
            }
          });
        }}>
        <span className={cx('iconfont', 'icon-list', styles.icon)}></span>
        <p className={cx(styles.nameTip, 'ellipsis-one')}>分类</p>
      </div>
    );
  };

  getMarginStyle = () => {
    let obj = { marginLeft: '15px' };
    if (this.props.AppMod.token) {
      if (isHasRouteAuth(routeAuthCodeMap.CLASSIFICATION_ICON)) {
        obj = {};
      } else {
      }
    } else {
      obj = {};
    }
    return obj;
  };

  changeModalStauts(index) {
    const { couponList } = toJS(this.stores);
    if (index == couponList.length - 1) {
      couponList[index].couponRenewModal = false;
      this.stores.changeState({ couponList });
    } else {
      couponList[index].couponRenewModal = false;
      couponList[index + 1].couponRenewModal = true;
      this.stores.changeState({ couponList });
    }
  }

  /**
   * 顶部导航栏
   */
  renderNavBar = (hideNavbar) => {
    const { backgroundImgWrap, hasBackgroundImg } = this.stores;
    const { msgCount } = this.state;
    return (
      <Flex
        id="home-nav"
        className={cx(styles.navbar, {
          [styles.imgBg]: hasBackgroundImg,
          [styles.hidden]: hideNavbar
        })}
        style={{ '--imgBg': `url(${backgroundImgWrap.appImgUrl})` }}
        align="center">
        {/* 分类 */}
        {this.renderClassifyContent()}
        <Flex
          className={styles.navSearch}
          onClick={() => {
            // 各个功能点击次数统计埋点
            this.tranckFunctionClick('搜索', '');
            this.goSearch();
          }}>
          <i className={cx('iconfont', 'icon-search', styles.icon)} />
          <Flex.Item className={cx('ellipsis-one')}>请输入产品编号或产品名称</Flex.Item>
        </Flex>
        <Flex direction="row" align="center">
          {isHasRouteAuth(routeAuthCodeMap.PERSONAL_SIGN_IN) && (
            <div
              className={cx(styles.navRight, styles['nav-clock'])}
              onClick={() => {
                // 各个功能点击次数统计埋点
                this.tranckFunctionClick('打卡', 'PERSONAL_SIGN_IN');
                window.app.routerGoTo('/PunchClock');
              }}>
              <img
                src={`${CDN_BASE}/assets/imgs/clock/clock_black.png`}
                className={styles.iconImg}
              />
              <p className={cx(styles.nameTip, 'ellipsis-one')}>打卡</p>
            </div>
          )}
          <div
            className={styles.navRight}
            onClick={() => {
              // 各个功能点击次数统计埋点
              this.tranckFunctionClick('消息', '');
              const { token } = this.appStore;
              token && window.app.routerGoTo('/personal/message');
              !token && window.app.routerGoTo('/login');
            }}>
            <img src={`${CDN_BASE}/assets/imgs/promote/message.png`} className={styles.iconImg} />
            <p className={cx(styles.nameTip, 'ellipsis-one')}>消息</p>
            {!!msgCount && (
              <span className={styles.msgCount}>{msgCount > 9 ? '9+' : msgCount}</span>
            )}
          </div>
        </Flex>
      </Flex>
    );
  };

  /**
   * 悬浮窗
   */
  renderFloatWindow = () => {
    const { floatWindow } = this.stores;
    if (!floatWindow.imgData) return null;
    const { windowName = '' } = floatWindow || {};
    return (
      <div
        className={cx({
          'float-window': true,
          'float-window-hide': this.state.isHide
        })}
        onClick={() => {
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick(`悬浮窗--${windowName || ''}`, '');
          // window.app.routerGoTo({
          //   pathname: '/shop/home/birthdayCardView'
          // });
          this.handleAction(floatWindow);
        }}>
        <ImgWrap src={floatWindow.imgData.imgUrl} mode="full" w="100%" h="100%" />
        <div
          className="close-btn"
          onClick={(e) => {
            e.stopPropagation();
            this.stores.changeState({ floatWindow: {} });
          }}>
          <span className="iconfont icon-reeor" />
        </div>
      </div>
    );
  };

  // 登录后-首页显示去升级的悬浮栏
  renderToUpgradeTip() {
    const { userInfo, token } = this.appStore;
    const { cardType } = userInfo || {};
    const { prompt = '' } = this.stores.noticeDetail || {};
    const values = Util.getLocalCache('couponTip');
    // 优惠券
    // if (values) return null;
    // // 复消悬浮滚动条
    // if (prompt) return null;
    if (!token || !isHasRouteAuth(routeAuthCodeMap.UPGRADE_FLOATWIN) || cardType !== -1) {
      return null;
    }
    return (
      <div className="to-upgrade-tip">
        <Flex align="center">
          <img
            className="tip-icon"
            src={`https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/bronze.png`}
          />
          <span className="tip-desc">升级享受更多权益</span>
        </Flex>
        <Flex>
          <CommonBtn
            className="tip-button"
            title="立即升级"
            onClick={() => this.stores.applyNextUpgrade(cardType)}
          />
          {this.topValue > window.innerHeight && (
            <img
              className="tip-icon-top"
              src={`https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/back_to_top.png`}
              onClick={() => {
                this.containerDom.scrollTo(0, 0);
              }}
            />
          )}
        </Flex>
      </div>
    );
  }

  /**
   * 优惠券提醒
   */
  renderCouponTip = () => {
    const values = Util.getLocalCache('couponTip');
    if (!values) return;
    return (
      <Flex className="float-coupon-window" onClick={() => {}}>
        <Flex className="float-coupon-view" justify="between">
          <Flex>
            <Flex
              className="del"
              onClick={() => {
                let value = Util.getLocalCache('couponTip');
                value.show = false;
                Util.setLocalCache('couponTip', value);
                this.setState({ showCoupon: false });
              }}>
              x
            </Flex>
            <Flex
              onClick={() => {
                window.app.routerGoTo('/member/wallet/coupon');
              }}
              alignItems="center"
              className="coupon-text">
              {`您有${values.count}张优惠券待使用，快去使用`}
            </Flex>
          </Flex>
          <Flex
            className="look-detail"
            onClick={() => {
              window.app.routerGoTo('/member/wallet/coupon');
            }}>
            立即查看
          </Flex>
        </Flex>
      </Flex>
    );
  };

  renderNotice = () => {
    const repeatPromptList = this.stores.repeatPromptList || [];
    const currentNoticeIndex = this.currentNoticeIndex || 0;
    if (!repeatPromptList.length || currentNoticeIndex >= repeatPromptList.length) return null;
    const { prompt = '', linkContent = '', type } = repeatPromptList[currentNoticeIndex] || {};
    if (!prompt) return null;
    return (
      <BuyAgainBar
        key={currentNoticeIndex}
        text={prompt}
        actionBtn={{
          visible: type === 4,
          text: '立即前往',
          onClick: (e) => {
            e.stopPropagation();
            this.handerNotice(linkContent, type);
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
          this.handerNotice(linkContent, type);
        }}
        onClose={() => {
          this.currentNoticeIndex = currentNoticeIndex + 1;
          this.forceUpdate();
        }}
      />
    );
  };

  renderLinkStoreInfoCell = () => {
    const { linkStoreInfo } = this.stores;
    if (!linkStoreInfo || !Util.getLocalCache('onlineAddress') === '1') return;
    return (
      <LinkStoreInfoCell
        containerStyle={{
          margin: `${cellMargin} 0`,
          width: `calc(100vw - 2 * ${cellMargin})`,
          marginBottom: '26px',
          backgroundColor: '#ffffff',
          padding: '24px',
          borderRadius: '8px'
        }}
        data={linkStoreInfo}
      />
    );
  };

  renderStoreInfoCell = () => {
    const { storeInfo } = this.stores;
    // 未登录不显示店铺信息
    if (!this.appStore.token || !storeInfo || Util.getLocalCache('onlineAddress') === '1') {
      return null;
    }
    return (
      <StoreInfoCell
        containerStyle={{
          margin: `${cellMargin} 0`,
          width: `calc(100vw - 2 * ${cellMargin})`,
          marginBottom: '26px',
          backgroundColor: '#ffffff',
          padding: '24px',
          borderRadius: '8px'
        }}
        data={storeInfo}
      />
    );
  };

  /**
   * banner位
   * @param {Array} list -banner列表
   */
  renderBanner = () => {
    const { isShowFixBar } = this.state;

    const { isBannerLoaded, bannerList } = this.stores;
    let list = (bannerList || []).slice(0);
    list = list.filter((item) => item.displayMode !== 1);
    // console.log('list123123', list);
    return (
      <div id="home-banner" className={styles.bannerBlock}>
        {this.renderNavBar(isShowFixBar)}
        {/* 指定线上地址 */}
        {this.renderLinkStoreInfoCell()}
        {/* 店铺信息模块 */}
        {this.renderStoreInfoCell()}
        <BannerCell
          loadEnd={isBannerLoaded}
          mediasList={list}
          width={`calc(100vw - 2 * ${cellMargin})`}
          height={'2.96rem'}
          // changeBg={(url) => this.stores.searchAverageColor(url)}
          onPress={(data) => {
            const { id, isBigDataRecommend } = data || {};
            // 埋点
            window.sensors.track('homeBannerClick', {
              banner_id: id || '',
              is_recommend: isBigDataRecommend ? 1 : 0 // 是否智能推荐,
            });
            // 各个功能点击次数统计埋点
            this.tranckFunctionClick('banner', '');
            this.handleAction(data);
          }}
        />
        {/* 固定按钮 */}
        {this.renderBannerBtn()}
      </div>
    );
  };

  /**
   * banner上固定按钮（显示位置后台动态配置）
   */
  renderBannerBtn = () => {
    const { buttonList } = this.stores;
    if (!buttonList.length) return null;
    const { bannerHeight, navbarHeight } = this.state;
    const visibleHeight = bannerHeight - navbarHeight; // banner除navbar遮挡外的高度
    const splitHeigt = visibleHeight / 5; // 分成5份，每一份的高度
    const positions = [0, splitHeigt, splitHeigt * 2, splitHeigt * 3, visibleHeight]; // 最后一份要贴底
    return buttonList.map((button) => {
      const style =
        +button.position == 4 ? { bottom: 0 } : { top: positions[+button.position] + navbarHeight };
      return (
        <div className="banner-btn" style={style} onClick={() => this.handleAction(button)}>
          <img src={button.imgUrl || ''} loading="lazy" />
        </div>
      );
    });
  };

  /**
   * 健康时刻表
   */
  renderHealthTimeLine = (data) => {
    const {
      chromaticValue,
      clew,
      gregorian,
      hour,
      imgUrlmain,
      lunar,
      recommandId,
      solarTerm,
      extend,
      content,
      displayMode,
      id
    } = data;
    if (displayMode === 1) return;
    const WEEKMAP = {
      0: '星期日',
      1: '星期一',
      2: '星期二',
      3: '星期三',
      4: '星期四',
      5: '星期五',
      6: '星期六'
    };
    const day_of_week = WEEKMAP[moment(gregorian).format('d')];

    return (
      <Flex
        className="timelineContainer"
        align="center"
        style={{ backgroundImage: `url(${imgUrlmain})` }}
        onClick={() => this.handleAction({ type: 8, content, extend, recommandType: 98, id })}>
        <div className="calendarIcon">
          <img src={`${CDN_BASE}/assets/imgs/shop/home/calendar.png`} loading="lazy" />
        </div>
        <Flex direction="column" className="timelineWrapper" align="baseline">
          <Flex className="firstLine" align="center">
            <div>{`农历: ${lunar}`}</div>
            <div className="departLine" />
            <div>{day_of_week}</div>
          </Flex>
          <Flex className="secondLine" align="center">
            {!!solarTerm && <div>{`节气: ${solarTerm}`}</div>}
            {!!solarTerm && <div className="departLine" />}
            <div>{`时辰：${hour}时`}</div>
            {!!clew && (
              <div
                className="desc"
                style={{
                  '--color': chromaticValue,
                  '--maxWidth': solarTerm ? '252px' : '390px'
                }}>
                {clew}
              </div>
            )}
          </Flex>
        </Flex>
      </Flex>
    );
  };

  /**
   * 应用位渲染（通用）
   * @param {Object} options - { data, loadEnd, containerStyle }
   */
  renderApplicationCell = ({ data, loadEnd = true, containerStyle }) => {
    return (
      <ModuleCell
        containerStyle={
          containerStyle || {
            margin: `${cellMargin} ${cellMargin} 0`
          }
        }
        width={`calc(100vw - 2 * ${cellMargin})`}
        loadEnd={loadEnd}
        data={data || []}
        onPress={(item) => {
          this.tranckFunctionClick(`应用位--${item.name}`, '');
          this.handleAction(item);
        }}
      />
    );
  };

  /**
   * 应用位-应用列表 (banner下面)
   */
  renderApplication = () => {
    const { isAppLoaded, moduleDisplayMethod } = this.stores;
    const applicationList = toJS(this.stores.applicationList);
    if (moduleDisplayMethod == 1) return null; // 随机配置
    return this.renderApplicationCell({
      data: applicationList,
      loadEnd: isAppLoaded
    });
  };

  /**
   * 应用位-应用列表 (随机配置)
   */
  renderApplicationRandom = () => {
    const { isAppLoaded, moduleDisplayMethod } = this.stores;
    const applicationList = toJS(this.stores.applicationList);
    if (moduleDisplayMethod == 0) return null; //banner下面
    return this.renderApplicationCell({
      data: applicationList,
      loadEnd: isAppLoaded
    });
  };

  // 组合推荐位
  renderCombinedRecommend = (floor) => {
    if (floor && floor.displayMode == 1) return null;
    return <CombinedRecommend data={floor} />;
  };

  /**
   * 资格购产品列表推荐位
   */
  renderQualificationItemList = (floor) => {
    const activityId = (floor && floor.activityId) || this.stores.qualificationListActivityId;
    if (!activityId) return null;
    return (
      <div style={{ marginTop: cellMargin }}>
        <QualificationItemList
          ref={(ref) => {
            this.qualificationItemListRef = ref;
          }}
          showBv={this.stores.qualificationProductShowBv}
          activityId={activityId}
          defaultSelectedTagId={this.stores.qualificationSelectedTagId}
          onTagChange={(tagId) => {
            // 单页应用：存住选中的标签，从详情返回时恢复
            this.stores.qualificationSelectedTagId = tagId;
          }}
          defaultTagScrollX={this.stores.qualificationTagScrollX}
          onTagScroll={(x) => {
            // 存住标签栏横向滚动位置，从详情返回时恢复
            this.stores.qualificationTagScrollX = x;
          }}
          onPressItem={(item) => {
            window.app.routerGoTo({
              pathname: `/shop/productDetail/${item.itemId}`,
              search: Util.encodeQuery({
                activityId: item.activityId,
                activityType: 10
              })
            });
          }}
        />
      </div>
    );
  };

  /**
   * 资讯位
   */
  renderNews = () => {
    const { news, isNewsLoaded } = this.stores;
    const { globalAjaxJson } = this.appStore;
    if (!globalAjaxJson || globalAjaxJson.yofotoInformationSwitch != 1) return null;

    return (
      <ArticleCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        loadEnd={isNewsLoaded}
        data={news}
        width={'4.4rem'}
        height={'0.3rem'}
        onPress={() => {
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick('享资讯', '');
        }}
        onMorePress={() => {
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick('享资讯--更多', '');
        }}
      />
    );
  };

  /**
   * 推荐位
   * @param {Object} recommend -推荐位对象
   */
  renderRecommandCell = (recommend) => {
    // console.log('推荐位recommend-------', recommend);
    // 0.对称宫格 1.横向宫格 2.不对称三宫格1 3.不对称三宫格2
    const { combinationType, datas } = recommend;
    let list = datas || [];
    list = list.filter((item) => item.displayMode !== 1);
    if (list.length === 0) return;

    return (
      <RecommandCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        multipleMargin={cellMargin}
        combinationType={combinationType}
        data={list || []}
        onPress={(item) => {
          const { content } = item;
          let recommendName = '';
          switch (combinationType) {
            case 0:
              recommendName = '对称宫格';
              break;
            case 1:
              recommendName = '横向宫格';
              break;
            case 2:
              recommendName = '不对称宫格1';
              break;
            case 3:
              recommendName = '不对称宫格2';
              break;
            default:
              break;
          }
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick(`推荐位--${recommendName}`, '');
          try {
            if (combinationType == 1) {
              if (
                content != 'https://h5.yofogo.com/commonweal' &&
                content &&
                JSON.parse(content) &&
                JSON.parse(content).route === 'Yundian'
              ) {
                Modal.alert('温馨提示', '请到有享云商app进行操作');
                return;
              }
            }
          } catch (error) {}

          this.handleAction(item);
        }}
      />
    );
  };

  /**
   * 进度条
   */
  renderProgress(progress) {
    return (
      <Flex className="progress">
        <div className="bar" style={{ width: `${progress}%` }} />
      </Flex>
    );
  }

  /**
   * 直播列表
   */
  renderLiveList = (itemData) => {
    if (itemData && itemData.displayMode === 1) return null;
    const { data = [], configType } = itemData || {};
    return (
      <div style={{ margin: `${cellMargin} ${cellMargin} 0` }}>
        <LiveList
          data={toJS(data)}
          onPress={(e) => {
            const { content } = e;
            this.stores.changeState({
              liveRoomId: content.id || '',
              showWeappModal: true,
              liveCoverUrl: content.share_img || '',
              wechatAppid: 'gh_825754bbda7f'
            });
          }}
          showIntro={!!configType}
        />
      </div>
    );
  };

  renderTabFrameWork = () => {
    return (
      <div style={{ padding: `${cellMargin} 0.3rem` }}>
        {/* 三宫格图块 */}
        <div className="tab-frameWork-container">
          {[0, 1, 2].map((i) => (
            <Shape
              key={`three-recommend-list-${i}`}
              w="calc((100% - 0.24rem) / 3)"
              h="calc((100vw - 0.48rem - 0.24rem) / 3)"
              r="0.08rem"
            />
          ))}
        </div>

        {/* 两列大图 */}
        <div className="tab-frameWork-container">
          {[0, 1].map((i) => (
            <Shape
              key={`tow-line-list-${i}`}
              w="calc((100% - 0.16rem) / 2)"
              h="1.8rem"
              r="0.08rem"
            />
          ))}
        </div>

        {/* 三列商品 */}
        <div className="tab-frameWork-container">
          {[0, 1, 2].map((i) => (
            <div key={`three-line-list-${i}`} style={{ flex: 1 }}>
              <Shape
                w="100%"
                h="calc((100vw - 0.48rem - 0.16rem) / 3)"
                r="0.08rem"
                style={{ marginBottom: '0.12rem' }}
              />
              <Shape w="100%" h="0.24rem" r="0.04rem" style={{ marginBottom: '0.08rem' }} />
              <Shape w="70%" h="0.2rem" r="0.04rem" style={{ marginBottom: '0.08rem' }} />
              <Shape w="50%" h="0.2rem" r="0.04rem" />
            </div>
          ))}
        </div>

        {/* 分类 tab 条 */}
        <div className="tab-frameWork-container">
          {[0, 1, 2, 3, 4].map((i) => (
            <Shape key={`classfiy-tab-list-${i}`} style={{ flex: 1 }} h="0.56rem" r="0.28rem" />
          ))}
        </div>
      </div>
    );
  };

  /**
   * 导航栏TabBar
   */
  handleNavTabClick = (tab, index) => {
    if (tab.linkRecommandId === MallType.CROSS_INDUSTRY) {
      if (!this.appStore.token) {
        window.app.routerGoTo('/login');
        return;
      }
      const path = '/pagesMiddle/dedao_cps/aggregation_index';
      this.handleAction({
        type: 1,
        content: `${getCrossIndustryHiBuyUrl(path)}`
      });
      return;
    }

    this.stores.changeState({
      initialPage: index,
      tabFloorList: []
    });
    // 记录用户手动选择的 tab，刷新时优先恢复
    this.stores.userSelectedPage = index;
    this.stores.refreshTabData();
  };

  renderNavTabBar = (data) => {
    if (!data || !data.tabbarList || data.tabbarList.length === 0) return null;

    const { initialPage, tabFloorList, tabBannerList, tabModuleList, tabDataCache } = this.stores;
    const { tabbarList } = data;

    const tabs = tabbarList.map((item, index) => {
      return {
        linkRecommandId: item.linkRecommandId,
        title: '',
        sub: index,
        imgUrl: item.imgUrl ? JSON.parse(item.imgUrl).imgUrl : '', // 当前tab选中时显示的图
        imgUrlCover: item.imgUrlCover ? JSON.parse(item.imgUrlCover).imgUrl : '', // 当前tab未选中的时候的默认图，当左侧锚点选中的时候imgUrlLeftSelected没值，就用当前值显示，当右侧锚点选中的时候imgUrlRightSelected没值，就用当前值显示
        imgUrlLeftSelected: item.imgUrlLeftSelected
          ? JSON.parse(item.imgUrlLeftSelected).imgUrl
          : '', // 左侧锚点被选中时当前tab应该显示的图
        imgUrlRightSelected: item.imgUrlRightSelected
          ? JSON.parse(item.imgUrlRightSelected).imgUrl
          : '' // 右侧锚点被选中时当前tab应该显示的图
      };
    });

    const mallType = tabs[initialPage] && tabs[initialPage] && tabs[initialPage].linkRecommandId;

    const tabCount = tabs.length;
    const sizePct = 100 / tabCount;

    // 计算「某个 tab 被选中」时，每个 tab 应展示的图片：
    // 选中态用 imgUrl；选中项的右邻(其左侧被选中)用 imgUrlLeftSelected；
    // 选中项的左邻(其右侧被选中)用 imgUrlRightSelected；其余用兜底 imgUrlCover
    const pickUri = (tab, index, selIndex) => {
      if (index === selIndex) return tab.imgUrl;
      if (index === selIndex + 1) return tab.imgUrlLeftSelected || tab.imgUrlCover;
      if (index === selIndex - 1) return tab.imgUrlRightSelected || tab.imgUrlCover;
      return tab.imgUrlCover;
    };

    // 当前选中态下每个 tab 的切片图
    const currentSlices = tabs.map((tab, index) => pickUri(tab, index, initialPage));

    // 预加载所有状态会用到的图，切换不闪白
    // 用 tabs 的 URL 拼接作为缓存 key，只有 tabs 内容变化才重新生成
    const cacheKey = tabs.map((t) => `${t.imgUrl}|${t.imgUrlCover}`).join(',');
    let preloadUrls = this.tabPreloadCache.urls;
    if (this.tabPreloadCache.key !== cacheKey) {
      preloadUrls = [];
      tabs.forEach((_, selIndex) => {
        tabs.forEach((tab, index) => preloadUrls.push(pickUri(tab, index, selIndex)));
      });
      this.tabPreloadCache = { key: cacheKey, urls: preloadUrls };
    }

    return (
      <div className="nav-tab-bar" style={{ height: '100%', paddingTop: `${cellMargin}` }}>
        <div className="tab-bar-wrap" style={{ position: 'relative', padding: `0 ${cellMargin}` }}>
          {/* 占位元素：用一张切片(1/N 宽)按其固有比例撑起整条 bar 的高度 */}
          <img
            alt=""
            src={tabs[0].imgUrl || tabs[0].imgUrlCover}
            style={{
              width: `${sizePct}%`,
              display: 'block',
              visibility: 'hidden',
              verticalAlign: 'top'
            }}
          />
          {/* 用 canvas 把 N 段切片按整数设备像素首尾相接绘制成单一位图，彻底消除拼接缝 */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: `${cellMargin}`,
              right: `${cellMargin}`,
              height: '100%'
            }}>
            <NavTabBarCanvas slices={currentSlices} preloadUrls={preloadUrls} />
          </div>
          {/* 透明点击层：等分 N 个点击区域，缝隙不影响视觉 */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: `${cellMargin}`,
              right: `${cellMargin}`,
              height: '100%',
              display: 'flex',
              zIndex: 3
            }}>
            {tabs.map((tab, index) => (
              <div
                key={tab.sub}
                style={{ flex: 1, cursor: 'pointer' }}
                onClick={() => this.handleNavTabClick(tab, index)}
              />
            ))}
          </div>
        </div>
        <div>
          {tabFloorList && tabFloorList.length && tabDataCache[mallType] !== undefined ? (
            <div
              style={{
                width: '100vw'
              }}>
              {/* 消费tab - 累计节省金额 */}

              {this.renderAccumulatePriceTip(tabbarList[initialPage])}
              {this.renderTabContent({
                bannerList: tabBannerList,
                moduleList: tabModuleList,
                floorList: tabFloorList,
                currentTabData: tabbarList[initialPage]
              })}
            </div>
          ) : (
            this.renderTabFrameWork()
          )}
        </div>
      </div>
    );
  };

  /**
   * 渲染消费tab累计节省金额
   */
  renderAccumulatePriceTip = (currentTabData) => {
    const { totalDiscountAmount } = this.stores;
    if (
      !this.appStore.token ||
      currentTabData.linkRecommandId !== MallType.CONSUME ||
      totalDiscountAmount == null
    ) {
      return null;
    }
    return (
      <div
        style={{
          paddingLeft: cellMargin,
          paddingRight: cellMargin,
          marginTop: '0.24rem',
          marginBottom: '0.24rem'
        }}>
        <AccumulatePriceTip price={totalDiscountAmount} />
      </div>
    );
  };

  /**
   * 渲染Tab内容
   */
  renderTabContent = ({ bannerList, moduleList, floorList, currentTabData = {} }) => {
    return (
      <div style={{ width: '100%' }}>
        {/* Tab Banner */}
        {bannerList && bannerList.length > 0 && (
          <BannerCell
            loadEnd={true}
            mediasList={bannerList}
            onPress={(val) => {
              this.handleAction(val);
            }}
          />
        )}

        {/* Tab 应用位 */}
        {moduleList && moduleList.length > 0 && this.renderApplicationCell({ data: moduleList })}

        {/* Tab楼层内容 */}
        {floorList.map((floor, index) => {
          return this.renderFloorItem({
            floor,
            index,
            otherData: { mallType: currentTabData.linkRecommandId }
          });
        })}
      </div>
    );
  };

  /**
   * 轮播图
   */
  renderSliderCell = (itemData) => {
    if (itemData && itemData.displayMode === 1) return;

    return (
      <SliderCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={itemData}
        showBullets={false}
        onPress={(val) => {
          this.handleAction(val);
        }}
      />
    );
  };

  /**
   * 热卖宫格
   */
  renderHotProductList = ({ stickObj: floor, hiddenContent } = {}) => {
    if (floor && floor.displayMode === 1) return null;
    const { itemList } = toJS(floor) || {};
    // 无数据时不渲染
    if (!itemList || itemList.length === 0) return null;
    return (
      <div
        style={{
          margin: `${cellMargin} ${cellMargin} 0`,
          width: `calc(100vw - 2 * ${cellMargin})`
        }}>
        <Tabs list={itemList} hiddenContent={hiddenContent} sourceTag="首页" />
      </div>
    );
  };

  renderStickyHotProductList = ({ stickObj: floor, hiddenContent } = {}) => {
    if (floor && floor.displayMode === 1) return;
    const { itemList } = toJS(floor) || {};
    return (
      <Tabs
        ref={this.tabsStickyRef}
        callback={(idx) => this.tabsViewRef2.current.setIdx(idx)}
        list={itemList}
        hiddenContent={hiddenContent}
      />
    );
  };

  /**
   * 标题位
   * @param {Object} titleGuide -标题位对象
   */
  renderTitleCell = (titleGuide) => {
    if (titleGuide && titleGuide.displayMode === 1) return;

    return (
      <TitleCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={titleGuide}
        onPress={(val) => {
          this.tranckFunctionClick('标题栏', '');
          this.handleAction(val);
        }}
      />
    );
  };

  /**
   * 分类推荐
   * @param {Object} classify -分类推荐对象
   * @param {Object} otherData -其他数据，包含mallType等
   */
  renderClassifyCell = (classify, otherData = {}) => {
    if (classify && classify.displayMode === 1) return;
    const productParams = { sourceTag: '首页' };

    // 消费专区tab进入商品详情页需要默认选中复消订单
    if (otherData.mallType === MallType.CONSUME) {
      productParams.defaultOrderType = 2;
    }

    // 销售专区tab进入商品详情页需要带入globalSaleMode的标识位
    if (otherData.mallType === MallType.SALE) {
      productParams.globalSaleMode = 2;
    }

    return (
      <ClassifyCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={classify}
        productParams={productParams}
        onPress={(val) => {
          const { displayType, type, content, isBigDataRecommend } = val;

          if (type) {
            window.sensors.track('homeFloorClick', {
              line_type: type,
              link: content || '',
              is_recommend: isBigDataRecommend ? 1 : 0 // 是否智能推荐
            });
          }

          // 背景 + 6宫格需要添加生命周期埋点
          this.tranckFunctionClick(displayType == 3 ? '生命周期--更多权益' : '分类推荐', '');

          // 销售专区tab进入需要添加globalSaleMode参数
          const otherParams = {};
          if (otherData.mallType === MallType.SALE) {
            otherParams.globalSaleMode = 2;
          }

          this.handleAction({ ...val, ...otherParams });
        }}
      />
    );
  };

  /**
   * 广告图
   * @param {Object} advPicture -广告图对象
   */
  renderAdPictureCell = (advPicture) => {
    if (advPicture && advPicture.displayMode === 1) return;
    const { isDisplay, moduleClearance } = advPicture;
    let tmpData = [
      {
        type: advPicture.type || '',
        content: advPicture.content || '',
        title: advPicture.title || '',
        extend: advPicture.extend || '',
        imgInfo: advPicture.imgInfo || {},
        qwImgUrl: advPicture.qwImgUrl || '',
        itemId: advPicture.itemId || '',
        articleTypeId: advPicture.articleTypeId || ''
      }
    ];
    if (isDisplay) {
      tmpData.push({
        type: advPicture.type1 || '',
        content: advPicture.content1 || '',
        title: advPicture.title1 || '',
        extend: advPicture.extend1 || '',
        imgInfo: advPicture.imgInfo1 || {},
        qwImgUrl: advPicture.qwImgUrl1 || '',
        itemId: advPicture.itemId1 || '',
        articleTypeId: advPicture.articleTypeId1 || ''
      });
    }

    return (
      <AdPictureCell
        containerStyle={{
          margin: `${moduleClearance == 0 ? 0 : cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={tmpData}
        multipleMargin={moduleClearance == 0 ? '0rem' : '0.12rem'}
        onPress={(val) => {
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick('广告图', '');
          this.handleAction(val);
        }}
      />
    );
  };

  // 产品推荐
  renderGoodsCell = (itemData, otherData = {}) => {
    if (itemData && itemData.displayMode == 1) return;

    const productParams = { sourceTag: '首页' };
    // 消费专区tab进入商品详情页需要默认选中复消订单
    if (otherData.mallType === MallType.CONSUME) {
      productParams.defaultOrderType = 2;
    }

    // 销售专区tab进入商品详情页需要带入globalSaleMode的标识位
    if (otherData.mallType === MallType.SALE) {
      productParams.globalSaleMode = 2;
    }

    return (
      <GoodsCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={itemData}
        vertical={!itemData.isDisplay}
        horizontal={!!itemData.isDisplay}
        productParams={productParams}
        horizontalConfig={{
          size: '2.26rem',
          count: 3
        }}
        verticalConfig={{
          size: '2.26rem',
          count: 3
        }}
        onPress={(val) => {
          const { isBigDataRecommend, itemInfo } = val;
          const { itemId, id } = itemInfo;
          window.sensors.track('homeCommodityClick', {
            commodity_id: itemId || id || '',
            is_recommend: isBigDataRecommend ? 1 : 0 // 是否智能推荐
          });
        }}
      />
    );
  };

  /**
   * 产品楼层
   * @param {Object} data -楼层数据
   * @param {Object} otherData -其他数据，包含mallType等
   */
  renderGoodsFloorCell = (data, otherData = {}) => {
    if (data && data.displayMode === 1) return;

    const productParams = { sourceTag: '首页' };
    // 消费专区tab进入商品详情页需要默认选中复消订单
    if (otherData.mallType === MallType.CONSUME) {
      productParams.defaultOrderType = 2;
    }

    // 销售专区tab进入商品详情页需要带入globalSaleMode的标识位
    if (otherData.mallType === MallType.SALE) {
      productParams.globalSaleMode = 2;
    }

    return (
      <GoodsFloorCell
        containerStyle={{
          marginTop: cellMargin,
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={data}
        productParams={productParams}
      />
    );
  };

  /**
   * 三位图
   * @param {Object} threeImgs 三位图对象
   */
  renderThreeCell = (threeImgs) => {
    if (threeImgs && threeImgs.displayMode === 1) return;

    let tmpData = [
      {
        type: threeImgs.type || '',
        content: threeImgs.content || '',
        title: threeImgs.title || '',
        extend: threeImgs.extend || '',
        imgInfo: threeImgs.imgInfo || {}
      },
      {
        type: threeImgs.type1 || '',
        content: threeImgs.content1 || '',
        title: threeImgs.title1 || '',
        extend: threeImgs.extend1 || '',
        imgInfo: threeImgs.imgInfo1 || {}
      },
      {
        type: threeImgs.type2 || '',
        content: threeImgs.content2 || '',
        title: threeImgs.title2 || '',
        extend: threeImgs.extend2 || '',
        imgInfo: threeImgs.imgInfo2 || {}
      }
    ];

    return (
      <ThreeCell
        containerStyle={{
          margin: `${cellMargin} ${cellMargin} 0`
        }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={tmpData}
        multipleMargin={'0.12rem'}
        onPress={(item) => {
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick('三位图', '');
          this.handleAction(item);
        }}
      />
    );
  };

  /**
   * 图文推荐
   * @param {Object} -imgText 图文推荐对象
   */
  renderImgTextCell = (imgText) => {
    if (imgText && imgText.displayMode === 1) return;
    const tempData = [
      {
        imgUrl: imgText.imgUrl || '',
        type: imgText.type || '',
        content: imgText.content || '',
        title: imgText.title || '',
        summary: imgText.summary || '',
        extend: imgText.extend || ''
      },
      {
        imgUrl: imgText.imgUrl1 || '',
        type: imgText.type1 || '',
        content: imgText.content1 || '',
        title: imgText.title1 || '',
        summary: imgText.summary1 || '',
        extend: imgText.extend1 || ''
      }
    ];

    return (
      <ImgTextCell
        containerStyle={{ margin: `${cellMargin} ${cellMargin} 0` }}
        width={`calc(100vw - 2 * ${cellMargin})`}
        data={tempData}
        size={{
          width: '4.48rem',
          height: '2.16rem'
        }}
        onPress={(item) => {
          // 各个功能点击次数统计埋点
          this.tranckFunctionClick('图文推荐', '');
          this.handleAction(item);
        }}
      />
    );
  };

  getStickyObj() {
    const { floorList } = this.stores;
    const stickObj = (floorList || []).find((l) => l.renderType == 88) || {};
    return stickObj;
  }

  /**
   * 渲染单个楼层项
   * @param {Object} floor - 楼层数据
   * @param {number} index - 索引
   * @param {Object} otherData - 其他数据，包含mallType等
   */
  renderFloorItem = ({ floor, index, otherData = {} }) => {
    switch (floor.renderType) {
      case 1:
        // 推荐位
        return this.renderRecommandCell(floor);
      case 2:
        // 三位图
        return this.renderThreeCell(floor);
      case 3:
        // 图文推荐
        return this.renderImgTextCell(floor);
      case 4:
        // 分类推荐
        return this.renderClassifyCell(floor, otherData);
      case 5:
        // 广告图
        return this.renderAdPictureCell(floor);
      case 6:
        // 产品楼层
        return this.renderGoodsFloorCell(floor, otherData);
      case 7:
        // 标题
        return this.renderTitleCell(floor);
      case 8:
        // 产品推荐
        return this.renderGoodsCell(floor, otherData);
      case 23:
        return this.renderHealthTimeLine(floor.item);
      case 24:
        // 导航栏Tabbar
        return this.renderNavTabBar(floor);
      case 50:
        // 轮播图
        return this.renderSliderCell(floor);
      case 66:
        // 直播
        return this.renderLiveList(floor);
      case 1028: // 应用位随机配置
        return this.renderApplicationRandom(floor);
      case 117:
        // 组合推荐位
        return this.renderCombinedRecommend(floor);
      case 132:
        // 资格购产品列表推荐位
        return this.renderQualificationItemList(floor);
      case 88:
        // 热卖宫格，按实际顺序渲染（吸顶逻辑暂时去掉）
        return this.renderHotProductList({ stickObj: floor });
      default:
        return null;
    }
  };

  /**
   * 首页内容
   */
  renderHomeContent = () => {
    const { floorList, isFloorLoaded } = this.stores;
    // const stickObj = this.getStickyObj();
    return (
      <div style={{ paddingBottom: '96px' }}>
        {/* banner轮播图 */}
        {this.renderBanner()}
        {/* 资讯位 */}
        {this.renderNews()}
        {/* 应用列表 */}
        {this.renderApplication()}
        {!isFloorLoaded ? (
          <FloorFrame />
        ) : (
          floorList.map((floor, index) => this.renderFloorItem({ floor, index }))
        )}
        {/* 热卖宫格已移至 renderFloorItem(case 88) 按顺序渲染，吸顶逻辑暂时注释 */}
        {/* {isFloorLoaded && <div ref={this.tabsRef}>{this.renderHotProductList({ stickObj })}</div>} */}
      </div>
    );
  };

  // 移动端新人下载套餐广告
  renderPosterModal = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const { isAd, imgUrl } = this.stores.posterContent;
    if (!isAd) return null;

    return (
      <Modal
        title=""
        wrapClassName="posterModal"
        transparent
        visible={this.stores.isShowPoster && imgUrl}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <div
            style={{ width: '100%' }}
            onClick={() => {
              this.stores.changeState({ isShowPoster: false });
              this.stores.doLinkJump(this.stores.posterContent);
            }}>
            <img src={imgUrl} style={{ width: '100%', height: '100%' }} />
          </div>
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              this.stores.changeState({ isShowPoster: false });
            }}
          />
        </div>
      </Modal>
    );
  };

  renderBirthdayModal = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    if (this.props.AppMod.isShowBirthdayModal) return null;
    const { birthdayInfo } = this.stores;
    if (!birthdayInfo || !birthdayInfo.imgUrl) return null;

    let imgUrl = '';
    try {
      const imgJson = (birthdayInfo.imgUrl && JSON.parse(birthdayInfo.imgUrl)) || {};
      imgUrl = imgJson.imgUrl || '';
    } catch (error) {
      console.log('WindowCell - getImgUrl error', error);
      imgUrl = (birthdayInfo.imgUrl && birthdayInfo.imgUrl.imgUrl) || '';
    }

    return (
      <Modal
        title=""
        wrapClassName="posterModal"
        transparent
        visible={!this.props.AppMod.isShowBirthdayModal}>
        <div
          className="htmlGrey"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <div
            style={{ width: '100%' }}
            onClick={() => {
              this.props.AppMod.changeState('isShowBirthdayModal', true);
              this.stores.doLinkJump(birthdayInfo);
            }}>
            <img src={imgUrl} style={{ width: '100%', height: '100%' }} />
          </div>
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              const arr = this.stores.birthdayArr;
              const modalIndex = this.stores.modalIndex + 1;
              const targetObj = arr[modalIndex] || null;
              this.props.AppMod.changeState('isShowBirthdayModal', !targetObj);
              this.stores.changeState({ birthdayInfo: targetObj });
              this.stores.changeState({ modalIndex });
            }}
          />
        </div>
      </Modal>
    );
  };

  // 嘉年华跳转小程序弹窗
  renderCarnivalModal = () => {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const isProd = config.HOST === 'PROD';
    const userId = this.props.AppMod.userInfo.id || '';
    let path =
      (this.state.showCarnivalWeapplUrl || `pages/ThematicScreen/Carnival/index`) +
      (this.props.AppMod.token ? `?userId=${userId}` : '');
    let imgSrc = this.state.showCarnivalWeapplShareCard || '';
    return (
      <Modal
        title=""
        wrapClassName="posterModal"
        transparent
        visible={this.state.showCarnivalModal}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <div style={{ width: '100%' }}>
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_825754bbda7f"
              path={path}
              env-version={isProd ? 'release' : 'trial'}>
              <script type="text/wxtag-template">
                <img
                  src={modal_mini_program_image || imgSrc}
                  style={{ width: '540px', height: 'auto' }}
                />
              </script>
            </wx-open-launch-weapp>
          </div>
          <img
            style={{ width: '65px', marginTop: '58px' }}
            src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
            onClick={() => {
              this.setState({
                showCarnivalModal: false,
                showCarnivalWeapplUrl: '',
                showCarnivalWeapplShareCard: ''
              });
            }}
          />
        </div>
      </Modal>
    );
  };

  // 权益共享卡弹窗
  renderSupplementModal = () => {
    const {
      supplementData,
      showSupplementModal,
      supplementMsg,
      serverTime,
      activeActivityInfo = {}
    } = this.stores;
    if (!showSupplementModal) return null;

    let hasActive = false; // 是否可以进入活动信息
    const onShelfTime = moment(toJS(activeActivityInfo.onShelfTime)).unix();
    const offShelfTime = moment(toJS(activeActivityInfo.offShelfTime)).unix();
    const nowTime = moment(toJS(serverTime)).unix();
    if (onShelfTime < nowTime && nowTime < offShelfTime) {
      hasActive = true;
    }
    let msgHandle = 1; // 默认的报错
    if (supplementMsg) {
      if (supplementMsg == '已绑定当前主卡') {
        msgHandle = 2;
      } else if (supplementMsg.includes('客服处理')) {
        msgHandle = 3;
      }
    }
    return (
      // <Modal
      //   title=''
      //   transparent
      //   wrapClassName='posterModal'
      //   visible={showSupplementModal}
      //   onClose={() => this.doSupplementClose()}
      //   style={{width: '622px', marginTop: '-200px', zIndex: '99999'}}
      //   className='supplement_wrap'
      // >
      <div className="supplement_wrap">
        {/* <div className='supplement_wrap_mask' /> */}
        {!supplementData && (
          <div className="invite_fail">
            <div className="fail_title">温馨提示</div>
            <div className="fail_msg">{supplementMsg}</div>
            {msgHandle == 1 && (
              <div
                className="fail_btn"
                onClick={() => {
                  this.doSupplementClose();
                }}>
                关闭
              </div>
            )}
            {msgHandle != 1 && (
              <div className="fail_btn_2">
                <div
                  className="fail_btn_left"
                  onClick={() => {
                    this.doSupplementClose();
                  }}>
                  关闭
                </div>
                {msgHandle == 2 && (
                  <div
                    className="fail_btn_right"
                    onClick={() => {
                      this.goToActivity();
                    }}>
                    进入会场
                  </div>
                )}
                {msgHandle == 3 && (
                  <div
                    className="fail_btn_right"
                    onClick={() => {
                      this.goToCustomer();
                    }}>
                    在线客服
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {supplementData && (
          <div className="invite_success">
            <div className="invite_close">
              <img
                className="close_img"
                src={`${CDN_BASE}/assets/imgs/supplementaryCard/bind_cancel.png`}
                onClick={() => {
                  this.doSupplementClose();
                }}
              />
            </div>
            <img
              className="success_img"
              src={`${CDN_BASE}/assets/imgs/supplementaryCard/bind_success.png`}
            />
            {!hasActive && (
              <div
                className="no_ms_btn ms_text"
                onClick={() => {
                  this.doSupplementClose();
                }}>
                我已知晓
              </div>
            )}
            {!!hasActive && (
              <div className="has_ms_btn">
                <div
                  className="ms_left ms_text"
                  onClick={() => {
                    this.doSupplementClose();
                  }}>
                  先逛逛
                </div>
                <div
                  className="ms_right ms_text"
                  onClick={() => {
                    this.goToActivity();
                  }}>
                  进入会场
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      // </Modal>
    );
  };

  // #region 跳转小程序通用弹框
  renderMiniModal = () => {
    const { path, isProd = true, userName } = this.miniDateRef.current || {};
    const { showMiniModal } = this.state;
    if (!showMiniModal) return null;
    return (
      <CommonMiniModal
        {...{
          visible: showMiniModal,
          onClose: () => this.setState({ showMiniModal: false }),
          path,
          username: userName,
          isProd
        }}
      />
    );
  };

  // eslint-disable-next-line react/sort-comp
  goToActivity = () => {
    // 进入会场跳99微购
    window.app.routerGoTo(`/shop/home/special/1370824983965889552`);
    // 清除缓存的权益共享卡信息
    Util.setLocalCache('supplement_data', {});
    this.stores.changeState({
      showSupplementModal: false
    });
  };

  // 在线客服
  goToCustomer = () => {
    const { userInfo, token, onLineServiceUrl } = this.appStore;

    const { id: userId, cardCode } = userInfo || {};
    (function (w, d, n, a, j) {
      w[n] =
        w[n] ||
        function () {
          (w[n].a = w[n].a || []).push(arguments);
        };
      j = d.createElement('script');
      j.async = true;
      j.src =
        onLineServiceUrl ||
        'https://qiyukf.com/script/f5a2d07fcd2e3b1b63ee71412090db14.js?hidden=1';
      d.body.appendChild(j);

      ysf('config', {
        uid: this.appStore && this.appStore.userInfo ? this.appStore.userInfo.id : '',
        success() {
          window.sensors.track('contactCustomerService', {
            information_title: '在线客服',
            channal: 'H5',
            isLogin: !!token,
            userId: userId || '',
            cardCode: cardCode || ''
          });
          console.log('客户信息上报成功');
          ysf('onready', function () {
            ysf('open');
          });
        },
        error() {
          console.log('客户信息上报失败');
        }
      });
    })(window, document, 'ysf');
    // 清除缓存的权益共享卡信息
    Util.setLocalCache('supplement_data', {});
    this.stores.changeState({
      showSupplementModal: false
    });
  };

  // 关闭权益共享卡弹窗
  doSupplementClose = () => {
    this.stores.changeState({
      showSupplementModal: false
    });
    // 清除缓存的权益共享卡信息
    Util.setLocalCache('supplement_data', {});
    window.app.routerRedirect('/shop/home');
  };

  renderCouponRenewModal() {
    if (this.state.showImproveInfoModal || this.stores.AccoumnlateStatusV2) return null;
    const { couponList } = this.stores;
    let index = couponList.findIndex((item) => item.couponRenewModal);
    if (index < 0) {
      return;
    }
    return (
      <Modal
        wrapClassName="coupon-modal"
        visible={couponList[index].couponRenewModal}
        transparent
        onClose={() => {
          this.changeModalStauts(index);
          // this.setState({couponRenewModal: false});
        }}>
        <div className="coupon-modal-content">
          <p className="title">温馨提示</p>
          <p className="text">
            您的
            {couponList[index].couponName}到
          </p>
          <p className="text">
            <span className="left">{couponList[index].invalidTime} </span>
            <span className="right">
              到期,
              {couponList[index].delayText}
            </span>
          </p>
          <div
            className={cx('bottom', {
              'bottom-center': couponList[index].delayDay == 0
            })}>
            <div
              className="bottom-left"
              onClick={() => {
                this.changeModalStauts(index);
              }}>
              知道了
            </div>
            {couponList[index].delayDay > 0 && (
              <div
                className="bottom-right"
                onClick={() => {
                  this.stores.getDelayCoupon(
                    {
                      couponId: couponList[index].id
                    },
                    this.changeModalStauts(index)
                  );
                }}>
                延期
                {couponList[index].delayDay}天
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }

  // 未登录时-首页显示去注册的悬浮栏
  renderToRegisterTip() {
    const { upArrow: u = false } = this.state || {};
    if (this.appStore.token) {
      return null;
    }
    return (
      <LoginBottomTip
        showGoToTop={this.topValue > 0}
        goToTop={() => {
          const shophome = document.querySelector('#shop-home');
          const pullToRefreshRef = shophome.querySelector('.am-pull-to-refresh');
          pullToRefreshRef.scrollTop = 0;
        }}
      />
    );
  }

  // 显示吸顶tab 栏
  showStickyTabs = () => {
    const stickObj = this.getStickyObj();
    return (
      <Flex
        className={styles.stickyTab}
        style={{
          pointerEvents:
            this.getKeyFunc({ key: 'tabsStickyRef', func: 'getShowStatus' }) == 0 ? 'none' : 'auto'
        }}>
        {this.renderStickyHotProductList({ stickObj, hiddenContent: true })}
      </Flex>
    );
  };

  jumpToXM = (type = 1) => {
    // 1 消息 conversationList，2会议 meetingList
    if (!Util.isXM()) {
      Toast.fail('非享脉环境', 1.5);
      // return
    }
    let schema = 'conversationList';
    if (type == 2) {
      schema = 'meetingList';
    }
    try {
      if (Util.getVersion() == 'android') {
        XMAuthInterface.routerPage(schema);
      } else {
        window.webkit.messageHandlers.XMAuthInterface.postMessage({
          method: 'routerPage',
          params: {
            schema: schema
          }
        });
      }
    } catch (e) {
      console.log(e.toString());
      alert(e.toString());
    }
  };
  receiveAuthResult = (jsonString) => {
    alert('Received auth result for jsonString: ' + jsonString);
  };

  renderApplyModal = () => {
    const { showApply } = this.stores;
    return (
      <Modal
        visible={showApply}
        transparent
        maskClosable={false}
        onClose={() => {
          this.setState({
            showApply: false
          });
        }}
        className={styles.cancle_order_modal}>
        <div className={styles.modal_content}>
          <div className={styles.title}>温馨提示</div>
          <div className={styles.tip}>认证流程需至有享云商APP进行喔~</div>
          <Flex justify="around">
            <div
              className={cx(styles.btn_el, styles.btn_left)}
              onClick={() => {
                this.stores.changeState({
                  showApply: false
                });
              }}>
              取消
            </div>
            <div
              className={cx(styles.btn_el, styles.btn_right)}
              onClick={() => {
                window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.yofoto.yofoys');
                this.stores.changeState({
                  showApply: false
                });
              }}>
              去申请
            </div>
          </Flex>
        </div>
      </Modal>
    );
  };

  render() {
    const {
      staticRefreshing,
      floorRefreshing,
      hasPermissions,
      showModal,
      upgrate,
      member_userInfo,
      activityStartList,
      activityCountList,
      hasMoreItemInfos,
      needTimer,
      detailLength,
      activityBaseListLength,
      isStart,
      isCount,
      AccoumnlateStatusV2,
      tipContent,
      hasBackgroundImg,
      backgroundImgWrap
    } = this.stores;
    const { isShowFixBar, showCoupon, AccoumnlateStatus, showGoYundianOpenShop } = this.state;
    let _activityBaseList = [];
    if (activityBaseListLength == detailLength) {
      if (hasMoreItemInfos) {
        if (toJS(activityStartList).length > 0 && toJS(activityCountList).length > 0) {
          _activityBaseList = toJS(activityStartList).concat(toJS(activityCountList));
        }
      } else if (
        !hasMoreItemInfos ||
        isStart == activityBaseListLength ||
        isCount == activityBaseListLength * 2
      ) {
        _activityBaseList = toJS(activityStartList).concat(toJS(activityCountList));
      }
    }

    const isRefreshing = staticRefreshing || floorRefreshing;
    let showDownBar =
      (this.appStore.token && isHasRouteAuth(routeAuthCodeMap.DOWNLOAD_BOOT)) || hasPermissions;
    if (Util.isYofoto() || Util.isXM() || window.currentLng != 'cn') {
      // 隐藏下载
      showDownBar = false;
    }
    if (this.props.mode == 'finding')
      return (
        <div>
          {this.renderPosterModal()}
          {/* {this.renderBirthdayModal()} */}
          {this.renderCarnivalModal()}
          {this.renderMiniModal()}
          {this.renderWeappModal()}
          {this.renderWeappModalAdd()}
          {/* 跳转小程序 */}
          {this.renderWeappModalMore()}
          {/* 跳转小程序-申请开店 */}
          {!!showGoYundianOpenShop && this.renderGoToOpenShopModal()}
          {showModal && !this.state.showImproveInfoModal && !this.stores.AccoumnlateStatusV2 && (
            <CardOpenTip
              memberUserInfo={member_userInfo}
              upgrate={upgrate}
              callback={() => {
                this.stores.changeState({
                  showModal: false
                });
              }}
            />
          )}
          {this.renderCouponRenewModal()}
        </div>
      );

    const bgUrl = backgroundImgWrap.appImgUrl2 || '';
    let bodyStyle = {};
    if (bgUrl) {
      bodyStyle = {
        background: `url(${bgUrl}) no-repeat center`,
        backgroundSize: '100% 100%'
      };
    }
    return (
      <div
        id="shop-home"
        className={cx('shop-home', styles.shopHome)}
        style={bodyStyle}
        onScroll={() => {}}>
        {
          // 是否显示H5下载引导
          showDownBar && <DownloadBar hideBar={isShowFixBar} />
        }
        {this.renderNavBar(!isShowFixBar)}

        {/* 吸顶tab 栏（热卖宫格已移至 renderFloorItem 按顺序渲染，暂时注释）*/}
        {/* {this.showStickyTabs()} */}
        {/* 悬浮窗 */}
        {this.renderFloatWindow()}
        {/* 元宇宙弹窗 */}
        <XversePopup />
        {/* 消息弹窗 */}
        <HeaderMessageAlert></HeaderMessageAlert>
        {/* 红包雨弹窗 */}
        {(!!_activityBaseList.length || needTimer) && (
          <RedEnvelopeRain baseData={_activityBaseList} needTimer={needTimer} />
        )}
        {/* 优惠券提醒 */}
        {showCoupon && this.renderCouponTip()}
        {this.renderNotice()}
        {/* 首页背景图 */}
        {/* {hasBackgroundImg && (
          <div
            style={{
              width: '100vw',
              position: 'absolute',
              top: showDownBar ? (isShowFixBar ? 88 : '2.09rem') : 88,
              left: 0
            }}>
            <ImgWrap
              src={backgroundImgWrap.appImgUrl2}
              mode="full"
              w="100%"
              h={!isShowFixBar ? '100%' : 'calc(100% - 88px)'}
            />
          </div>
        )} */}
        {/* 下拉刷新组件 */}
        <PullToRefresh
          // disablePullToRefresh={true}
          damping={660}
          distanceToRefresh={82}
          style={{
            // height: document.documentElement.clientHeight - 96,
            height: '100%',
            overflow: 'auto'
          }}
          onScroll={(e) => this.saveScrollTop(e, showDownBar)}
          onTouchMove={(e) => {
            if (this.containerDom.scrollTop == 0) {
              this.setState({ hideNavbar: true });
            }
          }}
          onTouchEnd={(e) => {
            if (!isRefreshing) {
              this.setState({ hideNavbar: false });
            }
          }}
          indicator={{}}
          direction="down"
          refreshing={isRefreshing}
          // onRefresh={() => {
          //   this.stores.refreshData().then(() => {
          //     this.setState({ hideNavbar: false });
          //     this.stores.changeState({
          //       homeCarouselIndex: 1
          //     });
          //   });
          // }}
          className="disabled-refresh"
          onRefresh={() => {}}
          damping={0}>
          {this.renderHomeContent()}
        </PullToRefresh>
        <Footer active={0} />
        {AccoumnlateStatus && (
          <Accoumnlate
            callback={(showModal, data) => {
              this.setState({ AccoumnlateStatus: false });
              if (showModal) {
                this.stores.changeState({
                  showModal: true,
                  member_userInfo: data,
                  upgrate: false
                });
              }
            }}
          />
        )}
        {AccoumnlateStatusV2 && (
          <AccoumnlateV2
            shouldSupplyTag={tipContent.shouldSupplyTag}
            callback={(showModal, data) => {
              this.stores.changeState({ AccoumnlateStatusV2: false });
              if (!this.appStore.homePopupShow) {
                this.stores.isShowPoster && this.stores.queryNewcomer();
                !this.stores.isShowPoster && fetchData({ popupPosition: popupPositionMap.HOME });
                this.appStore.changeState('homePopupShow', true);
              }
            }}
          />
        )}
        {this.renderPosterModal()}
        {/* {this.renderBirthdayModal()} */}
        {this.renderCarnivalModal()}
        {this.renderMiniModal()}
        {this.renderWeappModal()}
        {this.renderWeappModalAdd()}
        {/* 跳转小程序 */}
        {this.renderWeappModalMore()}
        {/* 跳转小程序-申请开店 */}
        {!!showGoYundianOpenShop && this.renderGoToOpenShopModal()}
        {showModal && !this.state.showImproveInfoModal && !this.stores.AccoumnlateStatusV2 && (
          <CardOpenTip
            memberUserInfo={member_userInfo}
            upgrate={upgrate}
            callback={() => {
              this.stores.changeState({
                showModal: false
              });
            }}
          />
        )}
        {this.renderCouponRenewModal()}
        {/* 登录时不显示，未登录时，systemCode有值读getEnterList中下载app的权限点，systemCode没值读公司体系下载app的权限点 */}
        {!this.appStore.token && hasPermissions && this.renderToRegisterTip()}
        {/* 权益共享卡 */}
        {this.renderSupplementModal()}
        {this.renderToUpgradeTip()}
        {/* 跳转 链商小程序 */}
        <ToRecommenderWeapp
          jumpType={this.stores.commenderJumpType}
          visible={this.stores.showRecommenderWeapp}
          usernameStr={this.stores.usernameStr}
          onClose={() => {
            this.stores.changeState({ showRecommenderWeapp: false, commenderJumpType: 1 });
          }}
        />
        {/* <ToWeapp></ToWeapp> */}
        {/* 销售专区累计制必选产品未买提示弹窗 */}
        {this.state.showMustBuyModal && (
          <MustBuyModal
            onCancle={() => {
              this.setState({ showMustBuyModal: false });
            }}
            onConfirm={(firstProductId) => {
              this.setState({ showMustBuyModal: false });
              if (firstProductId) {
                window.app.routerGoTo({
                  pathname: `/shop/productDetail/${firstProductId}`
                });
              }
            }}
          />
        )}
        {this.renderApplyModal()}
      </div>
    );
  }
}

export default ShopHomeView;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/ShopHomeView.js